const sv = {
	ADD: "Lägg till",
	MATCH_ANY: "Någon",
	MATCH_ALL: "Alla",
	SAVE_FILTER: "Spara filter",
	UPDATE_FILTER: "Uppdatera filter",
	SHOW_RESULTS: "Visa resultat",
	MANAGE_FILTERS: "Hantera filter",
	NO_SAVED_FILTERS: "Inga sparade filter ännu",
	MODIFIED: "ändrad",
	MOVE_UP: "Flytta upp",
	MOVE_DOWN: "Flytta ner",
	ORG_CONSULTANT_FILTERS: "Konsultfilter",
	ORG_CONSULTANT_FILTERS_DESC:
		"Delade filter som alla kan använda på konsultlistan. Endast administratörer kan ändra dessa.",
	ADD_FILTER: "Lägg till filter",
	EDIT: "Redigera",
	HIDE: "Dölj",
	UPDATE: "Uppdatera",
	DONE: "Klar",
	LEARN_MORE: "Läs mer",
	NEW_FILTER: "Nytt filter",
	EDIT_FILTER: "Redigera filter",
	MY_FILTERS: "Mina filter",
	ORG_FILTERS: "Organisationsfilter",
	ORG_FILTERS_MANAGE_HINT: "Delade filter som hanteras av administratörer.",
	ORG_CONSULTANT_FILTERS_EMPTY_TITLE: "Inga konsultfilter ännu",
	ORG_CONSULTANT_FILTERS_EMPTY_DESC:
		"Skapa delade filter som hela organisationen kan använda för att snabbt avgränsa konsultlistan – t.ex. efter status, kompetens eller chef.",
	LIST_FILTERS: "Listfilter",
	ORG_CUSTOMER_FILTERS: "Kundfilter",
	ORG_CUSTOMER_FILTERS_DESC:
		"Delade filter som alla kan använda på kundlistan. Endast administratörer kan ändra dessa.",
	ORG_CUSTOMER_FILTERS_EMPTY_TITLE: "Inga kundfilter ännu",
	ORG_CUSTOMER_FILTERS_EMPTY_DESC:
		"Skapa delade filter som hela organisationen kan använda för att snabbt avgränsa kundlistan – t.ex. efter status, ort eller avtal.",
	FILTER_NAME: "Namn på filter",
	UPDATE_OR_CREATE_FILTER:
		'Du redigerar filtret "{{name}}". Vill du uppdatera det eller spara som ett nytt filter?',
	SAVE_AS_NEW: "Spara som nytt",
	GENDER: "Kön",
	MALE: "Man",
	FEMALE: "Kvinna",
	NOT_SET: "Ej angivet",
	MANAGER: "Konsultchef",
	SHOW_INACTIVE_MANAGERS: "Visa inaktiva konsultchefer",
	HIDE_INACTIVE_MANAGERS: "Dölj inaktiva konsultchefer",
	COMPETENCES: "Kompetenser",
	SAVE: "Spara",
	SAVE_SUCCESS_GENERIC: "Ändringarna sparades",
	FIRST_NAME: "Förnamn",
	LAST_NAME: "Efternamn",
	NAME: "Namn",
	EMAIL: "E-post",
	PERSONAL_NUMBER: "Personnummer",
	PHONE: "Telefon",
	ADDRESS: "Adress",
	EMERGENCY_CONTACT: "Närmast anhörig",
	ADDRESS_PLACEHOLDER: "Gata",
	ADDRESS_PLACEHOLDER_2: "C/O",
	TITLE: "Titel",
	PUBLIC_PRESENTATION: "Publik presentation",
	PUBLIC_PRESENTATION_AI_GENERATE: "Generera presentation",
	PUBLIC_PRESENTATION_AI_GENERATE_TOOLTIP_NO_COMPETENCES:
		"Lägg till kompetens(er) för att generera presentation",
	PUBLIC_PRESENTATION_AI_GENERATE_TOOLTIP_NO_CV:
		"Ladda upp konsultens CV för att generera presentation",
	PRIVATE_NOTES: "Interna anteckningar (ej synliga för konsult & kund)",
	EVENTS_NOTE: "Händelser (ej synliga för konsult eller kund)",
	INTERNAL_NOTES: "Interna kundanteckningar",
	PRIVATE_DESCRIPTION: "Intern beskrivning",
	SAVE_CHANGES: "Spara ändringar",
	EMPLOYEE_NO: "Anställningsnr",
	COPY: "Kopiera",
	LAST_ACTIVE_ON_APP: "Senast aktiv i appen",
	STATUS: "Status",
	JOBS: "Uppdrag",
	PROFILE: "Profil",
	COMPETENCE: "Kompetens",
	SKILL: "Egenskap",
	ADD_COMPETENCE: "Lägg till kompetens",
	INDUSTRY: "Bransch",
	SERVICE: "Tjänst",
	SALARY: "Löneuppgifter",
	EMPLOYMENT_AND_SALARY: "Anställning & lön",
	EMPLOYMENT: "Anställning",
	EMAIL_NOT_VALID: "Felaktigt telefonnummer",
	PHONE_NO_NOT_VALID: "Felaktigt telefonnummer",
	SOCIAL_SECURITY_NO_NOT_VALID: "Ange ett giltigt personnummer, ex 19901010-1122",
	ZIP_CODE_NOT_VALID: "Ange ett giltigt postnummer",
	CREATED: "Skapades",
	CREATED_BY: "Skapad av",
	UPDATED: "Uppdaterades",
	ADD_ROW: "Lägg till rad",
	SEARCH: "Sök",
	NO_SEARCH_RESULTS: "Inga sökresultat",
	LOGOUT: "Logga ut",
	DEACTIVATE: "Avaktivera",
	ACTIVATE: "Aktivera",
	LOGGING_OUT: "Loggar ut...",
	PASSWORD: "Lösenord",
	FORGOT_PASSWORD: "Glömt lösenord",
	RESET_PASSWORD: "Återställ lösenord",
	SET_PASSWORD: "Sätt lösenord",
	SET_PASSWORD_SUCCESS: "Lösenordet har uppdaterats",
	SEND: "Skicka",
	PASSWORD_REQUIRED: "Lösenord är obligatoriskt",
	PASSWORD_MISMATCH: "Lösenorden matchar inte",
	INVALID_TOKEN: "Återställningslänk är inte giltig längre.",
	PASSWORD_VALIDATION_MESSAGE:
		"Lösenord måste vara minst åtta tecken med minst en stor bokstav, en enkel bokstav och ett nummer",
	ROLE: "Roll",
	IS_ACTIVE: "Aktivt",
	ACTIVE: "Aktiv",
	ACTIVE_PLURAL: "Aktiva",
	INACTIVE: "Inaktiv",
	INACTIVE_PLURAL: "Inaktiva",
	DELETED: "Raderad",
	POSTAL_CODE_PLACEHOLDER: "Postnr",
	CITY_PLACEHOLDER: "Postort",
	FIELD_IS_REQUIRED: "Fältet är obligatoriskt",
	FIELD_MUST_BE_A_NUMBER: "Fältet måste vara ett nummer",
	NUMBER_REQUIRED: "Fältet måste vara ett nummer",
	SELECT_AT_LEAST_ONE_WEEKDAY: "Välj minst en veckodag",
	INVALID_TIME_FORMAT: "Ogiltig tidsformat (HH:MM)",
	MUST_BE_POSITIVE_OR_ZERO: "Värdet måste vara 0 eller högre",
	AT_LEAST_ONE_RULE_REQUIRED: "Minst en regel krävs",
	UNION_TYPE_INVALID: "Välj typ av kollektivavtal",
	EMPLOYMENT_TYPE_INVALID: "Välj anställningsform",
	PENSION_TYPE_INVALID: "Välj typ av tjänstepension",
	PHONE_PLACEHOLDER: "Telefonnummer",
	H: "tim",
	ECONOMY: "Ekonomi",
	ADMINISTRATION: "Administration",
	STAFFING: "Bemanning",
	CLOSE: "Stäng",
	COLUMNS: "Kolumner",
	COLUMNS_DRAG_HINT: "Dra för att ändra ordning",
	COLUMNS_RESET: "Återställ till standard",
	COLUMNS_MOVE: "Flytta kolumn",
	COLUMNS_PINNED_HINT: "Låst som första kolumn",
	COLUMNS_DND_PICKED_UP: "Plockade upp {{name}}. Position {{position}} av {{total}}.",
	COLUMNS_DND_OVER: "{{name}} flyttades till position {{position}} av {{total}}.",
	COLUMNS_DND_DROPPED: "{{name}} släpptes på position {{position}} av {{total}}.",
	COLUMNS_DND_CANCELLED: "Flytten av {{name}} avbröts.",
	COLUMNS_DND_INSTRUCTIONS:
		"Tryck på mellanslag för att plocka upp kolumnen. Använd piltangenterna för att flytta den. Tryck på mellanslag igen för att släppa den på sin nya position, eller escape för att avbryta.",
	FROM_TO: "Från - Till",
	OK: "Okej",
	ADD_ROWS: "Lägg till rad",
	NONE: "Inget",
	URL_PLACEHOLDER: "https://",
	DESELECT: "Avmarkera",
	UNSAVED_CHANGES: "Du har ändringar som ej är sparade, är du säker på att du vill gå vidare?",
	SELECT_PLACEHOLDER: "Välj",
	SELECT_DATE: "Välj datum",
	FLAG: "Flagga",
	BREAK_AND_DEDUCTION: "Rast/avdrag",
	SEARCH_JOB: "Sök uppdrag",
	SEARCH_CUSTOMER: "Sök kund",
	SEARCH_CONSULTANT: "Sök konsult",
	WARNING: "Varning",
	LOADING: "Laddar",

	// Customer
	CUSTOMERS: "Kunder",
	CUSTOMER_NO_SHORT: "Kundnr",
	VAT_NO: "Orgnr",
	CREATE_CUSTOMER: "Skapa kund",
	MANAGE_CORPORATE_GROUPS: "Lista/hantera koncernföretag",
	LIST_CUSTOMER_USERS: "Lista kundanvändare",
	CUSTOMER_USERS_LIST_TITLE: "Kundanvändare",
	CUSTOMER_USERS_FILTER_ACTIVE: "Aktiva",
	CUSTOMER_USERS_FILTER_INACTIVE: "Inaktiva",
	CUSTOMER_USERS_FILTER_ALL: "Alla",
	CUSTOMER_USERS_CUSTOMERS: "Kunder",
	NEW_CUSTOMER: "Ny kund",
	ACTIVATE_CUSTOMER_TITLE: "Aktivera kund",
	DEACTIVATE_CUSTOMER_TITLE: "Inaktivera kund",
	ACTIVATE_CUSTOMER_TEXT: "Är du säker på att du vill aktivera den här kunden",
	DEACTIVATE_CUSTOMER_TEXT: "Är du säker på att du vill inaktivera denna kund?",
	UNBLOCK_CUSTOMER_TITLE: "Ta bort kundförbud",
	UNBLOCK_CUSTOMER_TEXT: "Är du säker på att du vill ta bort kundförbudet?",
	SELECT_CUSTOMER: "Välj kund",
	NO_CUSTOMERS: "Det finns inga kunder för sökkriterierna",
	ORG_OR_PERSONAL_NUMBER: "Orgnr eller personnr",
	VISITING_ADDRESS: "Besöksadress",
	BASIC_INFO: "Grunduppgifter",
	STREET_ADDRESS: "Gatuadress",
	CUSTOMER_TYPE: "Kundtyp",
	IS_PRIVATE_PERSON: "Privatperson",
	INVOICE_NAME: "Fakturamottagare",
	SELECT_BOOKING_TYPE: "Välj bokningstyp",
	INVOICE_ADDRESS: "Faktureringsadress",
	INVOICE_ADDRESS_LINE_1_PLACEHOLDER: "Gatuadress eller box",
	INVOICE_ADDRESS_LINE_2: "Adressrad 2",
	REFERENCE: "Fakturareferens",
	REFERENCE_PLACEHOLDER: "Referens",
	GLN: "GLN-kod",
	GLN_PLACEHOLDER: "GLN-kod",
	EMAIL_INVOICE: "E-post vid PDF-faktura",
	EMAIL_INVOICE_PLACEHOLDER: "E-post",
	INVOICE_RECIPIENT: "Fakturamottagare",
	E_INVOICE: "Fakturaleverans",
	DATE_PLACEHOLDER: "ÅÅÅÅ-MM-DD",

	//Customer user
	REMOVE_USER_TITLE: "Ta bort användare",
	DELETE_USER_CONFIRMATION_TEXT: "Är du säker på att du vill ta bort användaren?",
	DELETE_USER_CONFIRMATION_BUTTON_TEXT: "Ja, ta bort användaren",
	CANCEL: "Avbryt",
	UNDO: "Ångra",
	YES: "Ja",
	NO: "Nej",
	CONTACT_PERSON: "Kontaktperson",
	SELECT_CONTACT: "Välj kontakt",
	OTHER_CONTACT_PERSON: "Ange ny kontaktperson",
	DESCRIPTION: "Beskrivning",
	CREATE_USER: "Skapa användare",
	UPDATE_USER: "Uppdatera användare",
	INVOICE_DETAILS: "Fakturainformation",
	USERS: "Användare",
	USER: "Användare",
	NEW_USER: "Ny användare",
	CONTRACT_AND_PRICES: "Avtal & priser",

	WEEK: "Vecka",
	DATE: "Datum",
	WEEKDAY: "Dag",
	START: "Start",
	END: "Slut",
	LENGTH: "Längd",
	SHIFTS: "Arbetspass",
	SHIFTS_BOOKED: "Bokade arbetspass",
	ADD_SHIFTS: "Lägg till arbetspass",

	RESOLVE: "Markera som hanterad",
	RESOLVED: "Hanterad",
	DECLINED_REASON: "Nekad kommentar",

	//CONTRACT
	CONTRACT: "Avtal",
	CONTRACTS: "Avtal",
	AGREEMENT: "Kollektivavtal",
	AGREEMENTS: "Kollektivavtal",
	NEW_CONTRACT: "Nytt avtal",
	CREATE_CONTRACT: "Skapa avtal",
	CONTRACT_INVOICE_DAYS: "Fakturadagar betalning",
	CONTRACT_INVOICE_DAYS_PLACEHOLDER: "Antal dagar",
	CONTRACT_FALLBACK: "Basavtal",
	CONTRACT_TERMS: "Villkor",
	OB: "OB",
	CONTRACT_SERVICE: "Tjänst",
	CONTRACT_SERVICE_HOURLY_PRICE: "Pris per timme (exkl. moms)",
	CONTRACT_SERVICE_VAT: "Moms",
	CONTRACT_SERVICE_ARTICLE_NUMBER: "Artikelnummer",
	CONTRACT_SERVICE_TIME: "Min tid per beställning",
	CONTRACT_PRICE_LIST: "Prislista",
	CONTRACT_PRICE_LIST_INFO: "Prislistan hämtas från avtal samt dess eventuella underavtal.",
	NO_PRICES: "Det finns inga priser",
	NO_CONTRACTS: "Det finns inga kontrakt för sökkriterierna",
	SELECT_CONTRACT: "Välj avtal",
	RUT_ROT_SETTINGS: "RUT / ROT-inställningar",
	COMPETENCE_DUPLICATED: "There has two or more price rows for same branch and service",
	OPEN_IN_NEW_TAB: "Öppna i ny flik",
	VALUE_SHOULD_INTEGER: "Value should be integer",

	//JOB
	MORE: "Mer",
	DELETE_JOB: "Ta bort uppdraget",
	DELETE_JOB_CONFIRM: "Är du säker på att du vill ta bort det här uppdraget?",
	DELETE_JOB_CONFIRM_BOOKED:
		"Är du säker på att du vill ta bort det här uppdraget? OBS! Notera att uppdraget redan är bokat och manuell hantering kan krävas.",
	DELETE_INVITATION: "Ta bort inbjudan",
	DELETE_INVITATION_CONFIRM: "Är du säker på att du vill ta bort den här inbjudan?",
	JOB: "Uppdrag",
	LONG_TERM: "Långtid",
	CUSTOMER: "Kund",
	OVERVIEW: "Översikt",
	SCHEDULE: "Schema",
	CONSULTANTS: "Konsulter",
	CANDIDATES: "Kandidater",
	MATCHING: "Matchning",
	EVENTS: "Händelser",
	INTERESTED: "Intresse",
	VISIBILITY: "Dolt",
	APPLICATION_AND_INVITATIONS: "Ansökningar",
	INVITED: "Önskad",
	SHOW_BOOKED_CONSULTANTS: "Visa bokade konsulter",
	BOOK: "Boka",
	DECLINE: "Neka",
	OPEN: "Öppet",
	REQUESTED: "Flaggad",
	BRANCH_IS_REQUIRED: "Ange bransch",
	SERVICE_IS_REQUIRED: "Ange tjänst",
	SHIFTS_IS_REQUIRED: "Ange minst ett arbetspass",
	JOB_CREATED_SUCCESSFULLY: "Uppdraget skapades",
	JOB_VIEW_CREATED: "Visa uppdraget",
	SOMETHING_WENT_WRONG: "Något gick fel",
	DASHBOARD_REFRESH_CACHE_TOOLTIP: "Uppdatera dashboardens cache",
	DASHBOARD_CACHE_REFRESHED: "Dashboardens cache uppdateras i bakgrunden",
	ONE_OR_MORE_ERRORS_IN_FORM: "Det finns ett eller flera fel i formuläret",
	FIX_VALIDATION_ERRORS_BEFORE_SAVING: "Åtgärda valideringsfel innan du sparar",
	NEW_JOB: "Nytt uppdrag",
	CREATE_JOB: "Skapa uppdrag",
	SUBMITTED: "Inskickad",
	FROM: "Från",
	TO: "Till",
	HOURS: "Timmar",
	HOURS_SHORT: "Tim",
	EMAIL_IS_REQUIRED: "E-post är obligatoriskt",
	FIRST_NAME_IS_REQUIRED: "Förnamn är obligatoriskt",
	LAST_NAME_IS_REQUIRED: "Efternamn är obligatoriskt",
	ACCOUNT_NO_IS_REQUIRED: "Kontonummer är obligatoriskt",
	BANK_NAME_IS_REQUIRED: "Kontonummer är obligatoriskt",
	CONSULTANT_CREATED: "Konsult har skapats",
	OPEN_CONSULTANT_PROFILE: "Ja, fortsätt fylla i egenskaper på konsulten",
	NOT_NOW: "Nej inte nu, gå till konsultlistan",
	NO_SHIFTS_MESSAGE: "Det finns inga arbetspass",
	NO_APPLICATION_MESSAGE: "Det finns inga ansökningar eller inbjudningar",
	NO_CONSULTANTS_MESSAGE: "Det finns inga matchande konsulter",
	ABOUT_WORKPLACE: "Om arbetsplatsen",
	END_DATE_START_DATE_VALIDATION: "Anställningens slutdatum kan inte vara före startdatum",
	END_DATE_START_DATE_REQUIRED_VALIDATION: "Startdatum och slutdatum krävs",
	END_DATE: "Slutdatum",
	NO_JOBS: "Det finns inga beställningar för sökkriterierna",
	JOB_DESCRIPTION: "Uppdragsbeskrivning",
	NUM_JOBS: "Antal uppdrag",
	SHIFTS_OVERLAP: "överlappar med ett nytt skift",
	SHOW_MORE_WEEKS: "Visa fler veckor",
	SHOW_PREV_WEEKS: "Tidigare veckor",
	BOOKING_TYPE: "Bokningstyp",
	BOOKING_TYPE_AUTO: "Autobokning",
	BOOKING_TYPE_OPEN: "Publicera till matchande konsulter",
	BOOKING_TYPE_INVITATION: "Bjud in konsulter",
	CONTACT_PERSON_IS_REQUIRED: "Kontaktperson måste anges",
	CITY: "Ort",
	POSTAL_CODE: "Postnummer",
	WEEK_NUMBER: "Vecka nummer",

	//Consultant
	NEW_CONSULTANT: "Ny konsult",
	NEW_AGREEMENT: "Nytt kollektivavtal",
	BANK: "Bank",
	SELECT_BANK: "Välj bank",
	BANK_ACCOUNT: "Bankkonto",
	START_DATE: "Startdatum",
	EMPLOYMENT_TYPE: "Anställningstyp",
	HOURLY_PAY: "Timlön (SEK)",
	TAX_FIELD: "Skatt",
	TABLE: "Tabell",
	TOT_HOURLY_PAY: "Inkl. semesterersättning ({{holidayPay}}%) {{tot}}, giltig från {{date}}",
	HOURLY_PAY_INFO: "Timlön exklusive semesterersättning",
	HOLIDAY_PAY: "Semesterlön",
	CREATE_CONSULTANT: "Skapa konsult",
	CREATE_AGREEMENT: "Skapa kollektivavtal",
	BASIC_DETAILS: "Basuppgifter",
	EMPLOYMENT_TYPE_REQUIRED: "Anställningstyp är obligatoriskt",
	SELECT_EMPLOYMENT_TYPE: "Välj anställningstyp",
	SELECT_HOLIDAY_PERCENTAGE: "Välj semesterlön (%)",
	TIME_REPORTS: "Tidrapporter",
	SELECT_ALL: "Markera alla",
	DESELECT_ALL: "Avmarkera alla",
	SALARY_DETAILS_REQUIRED: "Ange alla löneuppgifter",
	CONSULTANT: "Konsult",
	TIME: "Tid",
	DIFF_BILLED_TIME: "Diff fakturerbar tid",
	ACTIVE_CONSULTANT_CREATED_INFO:
		"Vill du fortsätta till konsultprofilen för att ange mer information?",
	INACTIVE_CONSULTANT_CREATED_INFO:
		"Observera att konsulten inte är aktiv, vilket innebär att konsulten inte kommer att visas i matchningar och inte heller kan logga in i appen förrän den är aktiverad.",
	CONSULTANT_HAS_CREATED: "Konsult har skapats",
	CUSTOMER_BLOCK: "Kundförbud",
	ADD_BLOCK: "Lägg till kundförbud",
	ACTIVATE_CONSULTANT_TITLE: "Aktivera konsult",
	DEACTIVATE_CONSULTANT_TITLE: "Inaktivera konsult",
	ACTIVATE_CONSULTANT_TEXT: "Är du säker på att du vill aktivera denna konsult",
	DEACTIVATE_CONSULTANT_TEXT: "Är du säker på att du vill inaktivera denna konsult",
	ACTIVATE_CONSULTANT_WARNING:
		"Konsulten aktiveras. Det innebär att det tidigare sista anställningsdatum, YYYY-MM-DD, försvinner från konsultens profil.",
	DEACTIVATE_CONSULTANT_WARNING:
		"Konsulten inaktiveras. Det innebär att sista anställningsdatum justeras till dagens datum, YYYY-MM-DD.",
	DELETE_CONSULTANT: "Ta bort konsult",
	DELETE_CONSULTANT_TEXT: "Är du säker på att du vill ta bort den här konsulten",
	AVAILABILITY: "Tillgänglighet",
	STATED_AVAILABILITY: "Angiven tillgänglighet",
	ACTUAL_AVAILABILITY: "Bokad tillgänglighet",
	BOOKING_STATE_BOOKED: "Bokad",
	BOOKING_STATE_FREE: "Ledig",
	TOMORROW: "Imorgon",
	DAY: "Dag",
	MONTH: "Månader",
	YEAR: "År",
	NO_CONSULTANTS: "Det finns inga konsulter för sökkriterierna",
	NO_BLOCKED_CUSTOMERS: "Konsulten har inga kundförbud registrerade",
	NO_COMPETENCE: "Inga kompetenser angivna",
	NO_FEEDBACKS: "Inga återkopplingar tillgängliga",
	ACTIVATION: "Inställningar",
	COMPETENCES_UPDATED: "Kompetens uppdaterades",
	INVALID_COMPETENCE: "Felaktig kompetens",
	PROVIDED_CONSULTANT_EMAIL_ALREADY_EXISTS: "Förutsatt att konsultens e-postadress redan finns",
	END_DATE_INFO:
		"Ett angivet slutdatum för anställningen innebär att konsulten kommer att inaktiveras vid detta datum och kommer bl.a. då inte att kunna använda sin konsultapp.",
	SHOW_JOB: "Gör publikt",
	HIDE_JOB: "Dölj uppdraget",
	SHOW_JOB_CONFIRM:
		"Är du säker på att du vill visa det här jobbet? Konsult kommer att kunna se detta jobb",
	HIDE_JOB_CONFIRM:
		"Är du säker på att du vill dölja det här jobbet? Konsult kommer inte att kunna se det här jobbet",
	DENY_JOB: "Neka uppdraget",
	DENY_JOB_CONFIRM: "Är du säker på att du vill neka det här jobbet?",
	DENY_JOB_SELECT_REASON: "Välj en orsak till att uppdraget nekas:",
	DENY_JOB_REASON_OTHER: "Annat",
	DENY_JOB_REASON_OTHER_PLACEHOLDER: "Ange orsak",
	DENIAL_REASON: "Nekningsorsak",
	DENIAL_REASONS: "Nekningsanledningar",
	DENIAL_REASONS_DESCRIPTION:
		"Anledningar som kan väljas när ett uppdrag nekas. Lämna tomt för att inte visa någon orsaksruta.",
	DENIAL_REASON_REQUIRED: "Kräv att en orsak anges vid nekande",
	DENIAL_REASON_ALLOW_OTHER: 'Tillåt fritextalternativet "Annat"',
	DENIAL_REASON_NAME_PLACEHOLDER: "Namn på anledning",
	DENIAL_REASON_ADD: "Lägg till anledning",
	RE_OPEN_JOB: "Öppna jobbet igen",
	CANCEL_JOB: "Avbryt uppdraget",
	RE_OPEN_JOB_CONFIRM: "Är du säker på att du vill öppna det här jobbet igen?",
	CANCEL_JOB_CONFIRM:
		"Är du säker på att du vill avbryta uppdraget? Notera att framtida arbetspass kommer avbokas, men eventuella arbetspass som redan påbörjats kommer behållas.",
	AGE: "Ålder",
	OPINION: "Omdöme",
	COMMENT: "Kommentar",
	FEEDBACK_LEFT_BY: "Omdömde lämnat av",

	ice: {
		iceName: "Närmsta anhörig",
		icePhone: "Telefon anhörig",
		iceNamePlaceholder: "Namn på exempelvis sambo eller förälder",
		icePhonePlaceholder: "Ange telefonnummer",
	},
	AVERAGE_WEEK_TIME: "Genomsnittlig veckotid",

	//Date Range Picker
	TODAY: "Idag",
	YESTERDAY: "Igår",
	THIS_WEEK: "Denna vecka",
	LAST_WEEK: "Förra veckan",
	THIS_MONTH: "Denna månad",
	LAST_MONTH: "Förra månaden",
	THIS_YEAR: "Detta året",
	LAST_YEAR: "Förra året",
	CUSTOM_RANGE: "Annat",
	WEEK_NO: "V",

	//time report status
	ATTESTED_INTERNALLY: "Internattesterad",
	APPROVED: "Godkänd",
	DECLINED: "Nekad",
	INVOICED: "Fakturerad",
	NOT_WORKED: "Ej arbetat",
	PENDING_REPORT: "Ej rapporterad",
	REPORTED: "Rapporterad",
	PLANNED_TIME: "Planerad tid",
	REPORTED_TIME: "Rapporterad tid",
	BREAK: "Rast (tim)",
	BILLED_TIME: "Debiterad tid",
	DEDUCTION: "Avdrag (SEK)",
	BILLABLE: "fakturerbar",
	NO_TIME_REPORTS: "Det finns inga tidsrapporter för sökkriterierna",
	PENDING: "Inväntar",
	INTERNAL_ATTEST: "Intern attest",
	CUSTOMER_ATTEST: "Kundattest",
	SILENT_ATTESTED: "Tyst attest",
	ATTEST: "Godkänn",
	FUTURE_TIME_REPORT: "Kommande",
	WORKED: "Rapporterad",
	NO_FILTER: "Alla",
	REPORT: "Rapportera",

	//Profile picture
	VIEW: "Visa",
	UPLOAD: "Ladda upp",
	REMOVE: "Ta bort",

	// recruitment
	RECRUITMENT: "Rekrytering",
	IN_REVIEW: "I process",
	HIRED: "Anställd",
	CANCELLED: "Avbruten process",
	// PROFILE_APPROVED: "Kravprofil godkänd",
	TAKE_REFERENCES: "Ta referenser",
	INTERVIEW_1: "Intervju 1",
	INTERVIEW_2: "Intervju 2",
	AGREEMENT_EXPIRED: "Avtal utgått",
	AGREEMENT_RECALLED: "Avtal återkallat",
	// TELEPHONE_INTERVIEW: "Telefonintervju",
	READY_TO_HIRE: "Redo att hyra",
	NEW_APPLICATION: "Ny ansökan",
	WAGE_SETTING: "Lönesättning",
	CANDIDATE_GETS_BACK: "Kandidat återkommer",
	CHARGE_REGISTER: "Belastningsregister",
	NOT_CURRENT: "Ej aktuell",
	// TEST: "Test",
	REFERENCE_TAKING: "Referenstagning",
	REFERENCE_TAKING_AND_CHARGE_REGISTER: "Referenstagning & Belastningsregister",
	INTRODUCTION: "Introduktion",
	// EMPLOYMENT_REPORT: "Anställningsredo",
	NO_THANKS: "Nej tack",
	CANDIDATE_DECLINED: "Kandidat tackat nej",
	NO_THANKS_SENT: "Nej tack skickad",
	AGREEMENT_SENT: "Avtal skickat",
	AGREEMENT_SIGNED: "Avtal signerat",
	CREATE_CANDIDATE: "Skapa kandidat",
	CURRENT_ACTION: "Aktivitet",
	NEXT_ACTION: "Nästa åtgärd",
	RECEIVED: "Mottagen",
	NEXT_ACTION_DATE: "Datum",
	RECRUITED: "Rekryterad",
	NEXT_ACTION_DATE_CHANGED: "Datum för nästa åtgärd uppdaterades",
	INTERVIEW_NOTES_UPDATED: "Intervjuanteckningar uppdaterades",
	NOTES: "Anteckningar",
	LAST_EDITED: "Senast ändrad",
	NO_CANDIDATES: "Inga kandidater",
	MESSAGE_SENT: "Meddelandet har skickats",
	NOTE_CHANGED: "Anteckning uppdaterades",
	BY: "av",
	NO_DATE: "Inget datum",
	NEW_CANDIDATE: "Ny kandidat",
	DOCUMENTS: "Bibliotek",
	HISTORY: "Historik",
	INTERVIEW: "Intervju",
	CHANGE_STATUS_TITLE: "Ändra kandidatens status",
	CHANGE_STATUS_TEXT: "Välj var kandidated är i rekryteringsprocessen",
	UPDATE_RECRUITMENT_STATUS: "Uppdatera",
	CANCEL_RECRUITMENT_STATUS_UPDATE: "Avbryt",
	RECRUITMENT_NOTES_ERROR: "Måste vara minst 10 tecken",
	SEND_MESSAGE_ACTION: "Skicka meddelande",
	MOVE_TO_CONSULTANT_POOL: "Flytta till konsultpool",
	SEND_MESSAGE_CANCEL: "Avbryt",
	USE_TEMPLATE: "Använd mall",
	DATE_PICKER_PLACEHOLDER: "Välj datum och tid",
	DOCUMENT_NAME: "Dokumentets namn",
	DOCUMENT_TYPE: "Typ av dokument",
	FILE_FORMAT: "Filformat",
	DRIVING_LICENSE: "Körkort",
	POLICE_RECORD_EXTRACTS: "Belastningsutdrag",
	VOCATIONAL_IDENTIFICATION: "Yrkeslegitimation",
	POLICE_EXTRACT_TYPE: "Typ av belastningsutdrag",
	POLICE_EXTRACT_TYPE_SCHOOL: "Skola",
	POLICE_EXTRACT_TYPE_CARE: "Vård",
	SELECT_POLICE_EXTRACT_TYPE: "Välj typ av belastningsutdrag",
	HAS_OVERLAPPING_SHIFTS: "Konsult har överlappande skift",
	COVER_LETTER: "Personligt brev",
	CV: "CV",
	CERTIFICATIONS: "Certifieringar",
	OTHER_DOCUMENTS: "Övriga dokument",
	OTHER: "Annat",
	EXPIRES: "Går ut",
	EXPIRE_DATE_PICKER_PLACEHOLDER: "Välj datum",
	UPLOAD_DOCUMENT: "Ladda upp fil",
	UPLOAD_JOB_DOCUMENTS: "Ladda upp dokument till uppdraget",
	UPLOAD_DOCUMENTS: "Ladda upp dokument",
	INTERVIEW_NOTES: "Intervjuanteckningar",
	INTERVIEW_NOTES_PLACEHOLDER: "Ange anteckningar här",
	CHOOSE_A_DOCUMENT_TYPE: "Välj typ av dokument",
	DRAG_AND_DROP_A_FILE: "Dra och släpp en fil här eller",
	BROWSE: "välj en fil",
	TO_UPLOAD: "att ladda upp",
	MAXIMUM_FILE_SIZE: "Max filstorlek är",
	MAXIMUM_FILE_COUNT: "Maximalt antal filer är",
	MAXIMUM_IMAGE_COUNT: "Maximalt antal bilder är",
	MAXIMUM_DOCUMENT_COUNT: "Maximalt antal dokument är",
	VALID_FILE_TYPES: "Giltiga filtyper => ",
	DELETE_DOCUMENT: "Ta bort dokument",
	DELETE_DOCUMENT_TEXT: "Vill du ta bort dokumentet",
	NO_DOCUMENT: "Det finns inga dokument",
	SEND_CONTRACT: "Skicka anställningsavtal",
	SUBJECT: "Ämne",
	SELECT: "Välj",

	mimeTypes: {
		"application/pdf": "PDF",
		"image/jpeg": "JPG",
	},

	//Weekdays
	MONDAY: "Måndag",
	TUESDAY: "Tisdag",
	WEDNESDAY: "Onsdag",
	THURSDAY: "Torsdag",
	FRIDAY: "Fredag",
	SATURDAY: "Lördag",
	SUNDAY: "Söndag",

	//Weekdays short
	MO: "Mån",
	TU: "Tis",
	WE: "Ons",
	TH: "Tor",
	FR: "Fre",
	SA: "Lör",
	SU: "Sön",

	WEEKDAYS_CHARS: "M T O T F L S",

	//Internal users
	ORGANISATION_ADMIN: "Administratör",
	ORGANISATION_CONSULTANT_MANAGER: "Konsultchef",
	INVITE_USER: "Bjud in användare",
	NO_USERS: "Det finns inga användare för sökkriterierna",
	SELECT_ROLE: "Välj roll",
	DELETE_USER: "Radera användare",
	DELETE_USER_CONFIRM: "Är du säker på att du vill ta bort den här användaren?",
	DEACTIVATE_USER_TITLE: "Inaktivera användare",
	ACTIVATE_USER_TITLE: "Aktivera användare",
	DEACTIVATE_USER_TEXT: "Är du säker på att du vill inaktivera den här användaren?",
	ACTIVATE_USER_TEXT: "Är du säker på att du vill aktivera den här användaren?",

	//absence
	ABSENCE: "Frånvaro",
	REASON: "Frånvaroorsak",
	REGISTER_ABSENCE: "Registrera frånvaro",
	ABSENCE_END_BEFORE_START: "Slutet kan inte vara före starten.",
	CHILD_CARE: "VAB",
	LEAVE_OF_ABSENCE: "Tjänstledig ",
	SICK_LEAVE: "Sjukfrånvaro",
	EDIT_ABSENCE: "Redigera frånvaro",

	//filters
	ALL: "Alla",
	NOT_BOOKED_TODAY: "Obemanade idag",
	NOT_BOOKED: "Obemannade",
	NOT_TODAY: "Inte idag",
	BOOKED: "Bokat",
	ACTIVE_BUT_NOT_ARCHIVED: "Aktiva",
	INACTIVE_BUT_NOT_ARCHIVED: "Inaktiva",
	ARCHIVED: "Arkiverade",

	// time report filters
	SELECT_CONSULTANT: "Välj konsult",
	SELECT_STATUS: "Välj status",

	KPI_DASHBOARD: "Dashboard",

	//Reports
	REPORTS: "Rapporter",
	JOB_ID: "Uppdragsnr",
	RATING: "Betyg",
	JOB_REPORTS: "Konsultrapporter",
	WORKED_WITH: "Arbetade med",
	GOOD_TO_KNOW: "Bra att veta",
	OVERALL_EXPERIENCE: "Övergripande erfarenhet",
	JOB_REPORT_DETAILS: "Arbetsrapport",
	FEEDBACK_REPORT: "Kundrapporter",
	SUBMITTED_BY: "Inskickad av",
	CONSULTANT_PUNCTUALITY_RATE: "Konsulten var punktlig",
	CONSULTANT_JOB_RATE: "Konsulten gjorde ett bra jobb",

	//Invoices
	INVOICES: "Fakturor",
	VAT_MUST_BE_POSITIVE: "VAT måste vara >= 0",

	//Salary
	/** The consultant detail tab showing that consultant's salary over time. */
	SALARY_VIEW: "Lönehistorik",
	/** The salary batch section under Ekonomi. Distinct from SALARY_VIEW. */
	SALARY_SECTION: "Lön",
	SALARY_BATCH: "Lönekörning",
	POOL: "Pool",
	NEW_SALARY_BATCH: "Ny lönekörning",
	SALARY_PROCESS_MODAL_TITLE: "Lönekörning har skapats",
	SALARY_PROCESS_MODAL_TEXT:
		"Du kan ladda ner ZIP som innehåller underlag för export till lönesystem nedan.",
	DOWNLOAD_FILE: "Ladda ner",
	DOWNLOAD_EXPORT_FILE: "Ladda ner exportfil",
	NOT_NOW_BUTTON: "Inte nu",
	SELECT_POOL: "Välj pool",
	SUBSIDIARIES: "Dotterbolag",
	SUBSIDIARY: "Dotterbolag",
	BELONGS_TO_SUBSIDIARY: "Tillhör dotterbolag",
	NO_SUBSIDIARY: "Inget dotterbolag",
	PREVIEW_SALARIES: "Förhandsgranska lön",
	SALARY_FOR_PERIOD: "Lön för period",
	SALARY_BREAKDOWN: "Lönespecifikation",
	VIEW_TIME_REPORTS: "Visa tidrapporter",
	NO_SALARY_PREVIEW: "Inget att visa här, välj datumintervall och tryck på 'Förhandsgranska lön'",
	SALARY_JOURNAL: "Lönejournal",
	RUN_SALARY: "Kör lön",
	CONFIRM_ROLLBACK_SALARY_BATCH:
		"Är du säker på att du vill rulla tillbaka lönekörningen? Detta kommer ändra tidrapporter i Origo, men inte ändra eller ta bort eventuella konsulter och löner som redan är exporterade till lönesystemet. Dessa bör hanteras manuellt i lönesystemet.",
	ROLLING_BACK_SALARY_BATCH: "Rolling back...",
	ROLL_BACK_SALARY_BATCH_SUCCESS: "Lönekörningen har rullats tillbaka",
	TOTAL: "Totalt",
	MISSING_SALARY_BATCH_INTERVAL: "Ange datum från och till",
	NUM_CONSULTANTS: "Antal konsulter",
	CLEARING_NO: "Clearingnr",
	WORKED_HOURS: "Arbetad tid",
	BREAK_HOURS: "Rast",
	GROSS_SALARY: "Bruttolön",
	TAX: "Skatt X%",
	DEDUCTION_AMOUNT: "Avdrag",
	TO_PAY: "Att utbetala",

	//Settings
	SETTINGS: "Inställningar",
	SERVICES_COMPETENCES: "Tjänster",
	ORG_SETTINGS: "Organisationsinställningar",
	NUMBER_SERIES: "Nummerserier",
	NOTIFICATIONS: "Notifieringar",
	NOTIF_LOGS: "Meddelandelogg",
	INTEGRATIONS: "Integrationer",
	API_LOGS: "API-logg",
	RESPONSE_TIME_STATS: "API responstider",

	FILTER: "Filtrering",
	CLEAR: "Rensa",

	pwReset: {
		confirmPassword: "Bekräfta lösenord",
	},

	contract: {
		name: "Avtalets namn",
		nameDesc: "Namn endast synligt internt",
		invoiceDays: "Fakturadagar betalning",
		invoiceDaysDesc: "Betalningsvillkor som appliceras på uppdrag som är knutna till detta avtal",
		activeDesc: "Aktivera för att möjliggöra att avtal används och knyts till kunder",
		terms: "Villkor",
		termsDesc: "Villkorstext som visas för kund i samband med beställning",
		privateDesc: "Intern beskrivning",
		privateDescDesc: "Anteckningar som endast är synligt internt",
		fallback: "Huvudavtal",
		fallbackDesc: "Avtal som träder in om aktuell tjänst inte finns prissatt i detta avtal",
		invoiceTemplate: "Fakturamall",
		invoiceTemplateDesc:
			"Styr vilka rader som skapas på fakturan och om kundens uppdrag samlas på en faktura (per kund) eller får en faktura var (per uppdrag). Kan överstyras per kund. Kontakta Origo för att skapa eller ändra en mall.",
		selectInvoiceTemplate: "Välj fakturamall",
		archivedInvoiceTemplate: "Arkiverad mall",
		rutRot: {
			forRut: "Är berättigad för RUT-avdrag",
			forRot: "Är berättigad för ROT-avdrag",
		},
		delete: {
			success: "Avtalet togs bort",
			failed: "Kunde inte ta bort avtalet",
			confirmTitle: "Är du säker på att du vill ta bort avtalet?",
			confirmText:
				"Genom att ta bort avtalet kommer det inte längre kunna användas för nya kunder.",
		},
		archived: "Arkiverat",
		hidden: "Synligt för kunder",
		showForCustomers: "Visa för kunder",
		hideForCustomers: "Dölj för kunder",
		select: "Välj avtal",
	},

	login: {
		haveYouForgottenPassword: "Har du glömt ditt lösenord?",
		email: "E-post",
		password: "Lösenord",
		login: "Logga in",
		failed: "Kunde inte logga in, vänligen försök med annat användarnamn och/eller lösenord",
		twoFactorPhoneMissing:
			"Din organisation kräver tvåfaktorsinloggning via SMS, men ditt konto saknar mobilnummer. Kontakta en administratör som lägger till ditt nummer, och försök sedan igen.",
		sessionExpired: "Din session har gått ut. Logga in igen.",
	},

	activateAccount: {
		title: "Aktivera ditt konto",
		password: "Välj lösenord",
		passwordConfirmation: "Bekräfta lösenord",
		activate: "Aktivera konto",
		failed: "Kunde inte aktivera kontot",
		success: "Kontot har aktiverats. Tryck på länken nedan för att logga in.",
		gotoLogin: "Gå vidare till inloggning",
	},

	deliveryMethod: {
		title: "Leveranssätt",
		label: {
			E_INVOICE_GLN: "E-faktura (GLN)",
			E_INVOICE_ORG: "E-faktura (org.nr)",
			EMAIL: "E-post",
			PRINT: "Utskrift",
		},
		managedByFortnox: "Styrs av Fortnox (uppdaterad {{date}})",
		privatePersonNoEInvoice: "E-faktura kan inte väljas för privatpersoner",
		timeline: {
			set: "Leveranssätt satt av Fortnox",
			released: "Leveranssätt styrs inte längre av Fortnox",
		},
		notConfirmedByFortnox: "Ej bekräftad av Fortnox",
		eInvoiceIntent:
			"Önskat leveranssätt. GLN-koden skickas till Fortnox vid nästa fakturakörning – fakturan går som E-post/Utskrift tills e-fakturakopplingen är aktiv i Fortnox.",
		intentCheck: {
			checking: "Kontrollerar e-fakturakoppling i Fortnox…",
			notInFortnox: "Kunden finns inte i Fortnox ännu – skapas vid första fakturakörningen",
			inactive: "Ej aktiv i Fortnox ännu – skickas som E-post/Utskrift tills kopplingen är aktiv",
		},
		fromCorporateGroup: "Hämtas från koncernen",
		missingVatNumber: "Kunden saknar org.nr — fyll i det under Grunduppgifter",
		field: {
			GLNCode: "GLN-kod (13 siffror) saknas",
			GLNFormat: "GLN-kod måste vara exakt 13 siffror",
			vatNumber: "Org.nr saknas",
			email: "E-postadress för faktura saknas",
		},
		managedMembers_one: "{{count}} medlem styrs av Fortnox och behåller sitt eget leveranssätt",
		managedMembers_other:
			"{{count}} medlemmar styrs av Fortnox och behåller sitt eget leveranssätt",
		refresh: {
			button: "Hämta från Fortnox",
			description:
				"Läser kundernas leveranssätt (e-faktura) och GLN från Fortnox och uppdaterar kunderna i Origo. Görs även vid varje fakturaexport.",
			success:
				"Hämtat från Fortnox {{time}}: {{managed}} kunder styrs av Fortnox, {{updated}} uppdaterades",
			lastRun: "Senast hämtat {{time}}",
		},
		refreshCustomer: {
			button: "Hämta e-fakturakoppling från Fortnox",
			saveFirst: "Spara dina ändringar först",
			notInFortnox: "Kunden finns inte i Fortnox ännu. Den skapas vid första fakturakörningen.",
			managed: "Fortnox har en aktiv e-fakturakoppling för kunden: {{method}}",
			unmanaged: "Fortnox har ingen aktiv e-fakturakoppling för kunden",
			updated: "Kunden uppdaterades",
			unchanged: "Inget ändrades",
		},
	},

	corporateGroup: {
		title: "Koncern",
		plural: "Koncerner",
		name: "Koncernnamn",
		select: "Sök koncern",
		selectPlaceholder: "Välj koncern",
		create: "Skapa koncern",
		createNew: "Skapa ny koncern",
		edit: "Redigera koncern",
		members: "Kunder i koncernen",
		noMembers: "Inga kunder ingår i koncernen ännu",
		memberCount: "Antal kunder",
		empty: "Inga koncerner",
		delete: "Ta bort koncern",
		deleteBlocked: "Koncernen kan inte tas bort så länge kunder ingår i den",
		selectRequired: "Välj eller skapa en koncern",
		invoiceDetailsOwnedByGroupTitle: "Observera",
		invoiceDetailsOwnedByGroup:
			"Kunden tillhör en koncern, faktureringsuppgifter hämtas från koncernen",
		referenceLabel: "Fakturareferens (per kund)",
		customerTypeCompany: "Företag",
		customerTypeCorporateGroup: "Företag i koncern",
		customFieldsTitle: "Anpassade fält",
		customFieldsHint: "Gäller alla kunder i koncernen och kan inte ändras på kunderna.",
	},

	customer: {
		name: "Kundnamn",
		namePlaceholder: "",
		invoiceName: "Företagsnamn (juridiskt namn)",
		gln: "GLN-kod vid E-faktura",
		invoiceTemplate: "Fakturamall",
		invoiceTemplateOverride: "Fakturamall (överstyr avtalets)",
		costCenter: "Kundens kostnadsställe",
		resultUnit: "Resultatenhet",
		invoiceTemplateFollowContract: "Följ avtalet",
		invoiceTemplateDesc:
			"Som standard används avtalets fakturamall. Välj en mall här för att ge just den här kunden en annan radlayout.",
		isSignup: "Självregistrerad",
		isSignupPlural: "Självregistrerade",
		isSignupShort: "Självreg.",
		numInactiveSignupsTooltip: "Antal självregistrerade kunder som ej aktiverats",
		internalNotes: "Interna kundanteckningar (ej synliga för konsult & kund)",
		created: {
			title: "Kunden har skapats",
			infoActive: "Du kan lägga till ytterligare information genom att besöka kundens profil.",
			infoInactive:
				"Notera att kunden ej är aktiv. Detta betyder att kunden ännu inte kan logga eller skapa uppdrag. Du kan redigera kundens instaällningar genom att besöka profilen.",
			yes: "Ja, öppna kundens profil",
			no: "Nej, inte nu",
		},

		user: {
			invite: "Bjud in",

			inviteModal: {
				title: "Bjud in {{name}}",
				text: "Användaren kommer att få en inbjudan skickad med en länk till ett formulär där denne kan ange sitt lösenord och instruktioner om hur man kommer igång.",
				success: "Inbjudan har skickats",
				failure: "Något gick fel, vänligen försök igen",
				emailLabel: "Skicka inbjudan via e-post {{email}}",
				smsLabel: "Skicka inbjudan via SMS {{phoneNo}}",
			},

			removeAccess: {
				title: "Ta bort åtkomst",
				text: "{{name}} kommer tas bort från {{customer}}. Notera att användare fortfarande har åtkomst till andra kunder.",
				remove: "Ja, ta bort åtkomst",
			},

			removeUser: {
				title: "Ta bort användare",
				text: "Vill du ta bort användare {{name}}? Om användare är kopplad till flera kunder kommer all åtkomst tas bort.",
				remove: "Ja, ta bort användare",
			},
		},

		duplicates: {
			warning: "Baserat på kundens adress hittades följande kunder som eventuellt är dubbletter",
			hint: "Tryck för att öppna kund i nytt fönster",
		},
	},

	job: {
		isBooked: "Bokad",
		copy: "Kopiera uppdrag",
		hourlyPrice: "Timpris",
		purchaseOrderNo: "Inköpsordernummer",
		invoiceReference: "Fakturareferens",
		invoiceReferenceHint: "Lämna tomt för att använda kundens fakturareferens",
		invoiceReferenceHintWithCustomer: "Lämna tomt för kundens: {{reference}}",
		customerOrderNo: "Kundens beställningsnummer",
		gflRate: "GFL-timpris (SEK/tim)",
		denied: "Uppdraget nekades",
		cancelled: "Uppdraget avbröts",
		deleted: "Uppdraget togs bort",
		reopened: "Uppdraget öppnades upp",
		createdByCustomer: "Skapat av kund",
		internalNotes: "Interna uppdragsanteckningar (ej synliga för konsult & kund)",
		shifts: {
			hint: "Håll ned shift samtidigt som du klickar för att redigera flera dagar på samma gång.",
			openTimeReports: "Visa tidrapporter (öppnas i ny flik)",
			hasWorkedShiftsError: "Det går inte att redigera arbetspass när arbetet har påbörjats",
			needsApproveInfo: "Ett eller flera arbetspass behöver godkännas",
			approve: "Godkänn",
			decline: "Neka",
			add: "Lägg till pass",
			assign: "Välj konsult",
			invalidShift: "Felaktigt pass, starttid måste vara före slut",
			errors: {
				noShifts: "Uppdraget måste innehålla minst ett arbetspass",
				pastInvitations: "Det går ej att bjuda in till pass som redan startat",
			},
			warnings: {
				absenceModified:
					"Ett eller flera pass med registrerad frånvaro kommer tas bort. Om du utför ändringarna kan sjukpenning och/eller VAB påverkas.",
				reportedTimeReportsModified:
					"Ett eller flera pass som tidrapporteras kommer tas bort. Om du utför ändringarna kommer även tidrapporten tas bort.",
			},
		},
		filters: {
			all: "Alla",
			booked: "Alla bokade",
			notBooked: "Obemannade",
			today: "Idag",
			notBookedToday: "Obemanade idag",
			tomorrow: "Imorgon",
			notBookedTomorrow: "Obemmanade imorgon",
			min14Days: "14+ dagar",
		},

		bookingType: {
			open: "Publicerat",
		},

		doNotPublish: "Dolt uppdrag",
		doNotPublishDesc: "Uppdraget syns ej för matchande konsulter",
		//autoBookingDesc: "Första sökande konsult blir automatiskt bokad",
		longTermTag: "+14 dagar",

		jobStatus: {
			open: "Öppet",
			booked: "Bokad",
			partiallyBooked: "Delvis bokad",
			declined: "Nekat",
			deleted: "Raderat",
			cancelled: "Avbrutet",
			accepted: "Bokad",
			acceptedAt: "Bokad {{date}}",
			createdBy: "Publicerades av {{name}}, {{date}}",
			declinedBy: "Nekades av {{name}}, {{date}}",
			declinedReason: "Anledning: {{reason}}",
			cancelledBy: "Avbröts av {{name}}, {{date}}",
			pending: "Ansökt",
			applicationDeclined: "Avbokad",
			applicationDenied: "Nekad",
			bookedWithUnmannedShifts: "Delvis bokat",
			booked_with_unmanned_shifts: "Delvis bokat",
			hidden: "Dolt uppdrag",
		},

		invitationStatus: {
			open: "Önskad",
			declined: "Önskad - tackat nej",
			expired: "Önskad ej svar",
		},

		action: {
			acceptApplication: "Boka",
			cancelApplication: "Avboka",
			book: "Boka",
			bookAll: "Boka alla lediga",
			decline: "Neka",
			inviteAll: "Önska alla",
			uninviteAll: "Rensa alla önskningar",
		},

		customerExperience: "Kunderfarenhet",
		customerExperienceShort: "Kunderf.",

		notifyMatchingConsultants: "Notifiera konsulter",

		application: {
			createdBy: "Ansökt {{date}}",
			acceptedBy: "Bokad av {{name}} {{date}}",
			accepted: "Bokad {{date}}",
		},

		consultantWasBooked: "Konsulten bokades på uppdraget",
		applicationWasDeclined: "Ansökan nekades",
		consultantWasUnbooked: "Konsulten avbokades",

		flag: "Flagga",
		contactPerson: "Beställare",
		invite: "Önska",
		invited: "Önskad",
		inviteAgain: "Önska igen",
		inviteDeclined: "Har tackat nej",
		hasApplied: "Har skickat ansökan",
		sendingInvitations: "Skickar inbjudningar",
		invitationsSent: "Inbjudningarna har skickats",
		invitationsFailed: "Inbjudningarna kunde inte skickas",
		invitationsPartiallyFailed: "{{failed}} av {{total}} inbjudningar kunde inte skickas",
		invitationDeleted: "Inbjudningar har tagits bort",
		matchJobsCompetence: "Matcha uppdrag",
		inviteInfo: "Ange den/de konsulter som ska bjudas in.",
		inviteRequiredFields:
			"Ange kund, kompetens och arbetspass för att matcha konsulter som kan bjudas in.",
		inviteInstructions:
			"Välj vilka konsulter du vill bjuda in i nästa steg efter att uppdraget skapats.",

		copyInfo: "Kopia av uppdrag #{{orderNumber}}",
		downloadOrderConfirmationCustomer: "Hämta uppdragsbekräftelse (kund)",
		downloadOrderConfirmationConsultant: "Hämta uppdragsbekräftelse (konsult)",
		orderConfirmationError: "Kunde inte hämta uppdragsbekräftelse, är uppdraget bokat?",
		pdfTemplateMissing:
			"Ingen PDF-mall är konfigurerad för organisationen. Skapa mallen under Inställningar → Notiser.",
	},

	consultant: {
		invite: "Bjud in",
		employeeNumber: "Anställningsnummer",
		salary: {
			supplement: "Lönetillägg",
			hourlySupplement: "Lönetilllägg per h (exkl. semesterersättning)",
			hourlySupplementTot: " Total timlön per h (timlön + lönetillägg) {{tot}}",
			hourlySupplementTotWithHolidayPay: "Total timlön per h (inkl. semesterersättning) {{tot}}",
			save: "Uppdatera lön",
			current: "nuvarande",
			validFrom: "Giltig från {{date}}",
			history: "Lönehistorik",
		},
		shifts: {
			jobsAndApplications: "Uppdrag och ansökningar",
			empty: "Konsult har inga bokade uppdrag eller ansökningar",
		},
		address: {
			city: "Ort",
		},
		doNotPublish: "Dölj matchande uppdrag",
		doNotPublishDesc:
			"Konsult kommer ej själv se matchande uppdrag utan endast de som hen blivit inbokad på.",
		activateDesc:
			"Aktivera så att konsult ska kunna logga in via appen och kunna matchas för uppdrag.",
		autoComplete: {
			placeholder: "Sök konsult",
		},
		title: "Befattning",
		union: "Fackförbund",
		collectiveAgreement: "Kollektivavtal",
		collectiveAgreementPlaceholder: "Välj kollektivavtal",

		employmentOptions: {
			pension: "Efter pensionering, fyllda 65 år",
			student: "Studerande",
			otherMainEmployment: "Annan huvudsaklig sysselsättning",
			title: "Anställningsform",
		},
		sendEmploymentCertificate: "Skicka till Arbetsgivarintyg.nu",
		sendContract: "Skicka avtal",
		sendContractTitle: "Skicka avtal till {{name}}",
		sendContractText: "Skicka anställningsavtal för signering med BankID.",
		sendContractSuccess: "Avtalet har skickats",
		sendContractMissingDetails: "Konsulten saknar e-post, personnummer eller lön",
		employment: {
			started: "Startdatum",
			ended: "Slutdatum",
			firstStarted: "Första anställningsdatum",
		},
	},

	collectiveAgreement: {
		showAssignedConsultants: "Visa tilldelade konsulter",
		assignedConsultants: "Tilldelade konsulter",
		noAssignedConsultants: "Inga konsulter tilldelade detta kollektivavtal",
		updateGuaranteedHours: {
			title: "Uppdatera kollektivavtal",
			usedByConsultants: "Detta kollektivavtal används av {{count}} konsult.",
			usedByConsultants_plural: "Detta kollektivavtal används av {{count}} konsulter.",
			autoUpdate:
				"Alla konsulter som använder detta avtal kommer automatiskt att uppdateras med de nya garanterade timmarna och lönerna.",
			updateAgreement: "Uppdatera avtal",
		},
	},

	reports: {
		excelExports: "Excel-export",
		customerReport: "Kunder",
		customerContactReport: "Kundkontakter",
		consultantReport: "Konsulter",
		candidateReport: "Kandidater",
		consultantWorkedHoursReport: "Konsulters arbetade timmar",
		soldHoursAndRevenueReport: "Sålda timmar & intäkter",
		dashboards: "Dashboards",
		newDashboard: "Ny dashboard",
		sharedWithMe: "Delade med mig",
		noDashboards: "Du har inga dashboards än. Skapa en med plusknappen.",
		unnamedDashboard: "Namnlös dashboard",

		customerReportTitle: "Kundrapport",
		customerContactReportTitle: "Kundkontakter",
		consultantReportTitle: "Konsultrapport",
		candidateReportTitle: "Kandidatrapport",
		consultantWorkedHoursReportTitle: "Konsultens arbetade timmar",
		soldHoursAndRevenueReportTitle: "Sålda timmar & intäkter",

		download: "Ladda ned",
		export: "Exportera",
		filters: {
			certification: {
				label: "Certifikat",
				placeHolder: "Alla",
			},
			certificationStatus: {
				label: "Status",
				placeHolder: "Alla",
				options: {
					valid: "Giltigt",
					expired: "Utgånget",
					missing: "Saknas",
				},
			},
			certificationExpiresBy: {
				label: "Går ut senast",
				placeHolder: "Välj datum",
			},
			branch: {
				label: "Bransch",
				placeHolder: "Alla",
			},
			service: {
				label: "Kompetens",
				placeHolder: "Alla",
			},
			startDate: {
				label: "Startdatum",
				placeHolder: "Välj startdatum",
			},
			endDate: {
				label: "Slutdatum",
				placeHolder: "Välj slutdatum",
			},
			range: {
				label: "Tidsspann",
				placeHolder: "Start och slut",
			},
			pool: {
				label: "Pool",
				placeHolder: "Välj pool",
			},
			contract: {
				label: "Avtal",
				placeHolder: "Välj avtal",
			},
			customer: {
				label: "Kunder",
				placeHolder: "Välj kunder",
			},
			status: {
				label: "Status",
				placeHolder: "Välj status",
			},
			currentAction: {
				label: "Nuvarande status",
				placeHolder: "Välj nuvarande status",
			},
			jobStatus: {
				label: "Uppgragsstatus",
				placeHolder: "Välj status",
				options: {
					open: "Öppet",
					booked: "Bokad",
					partiallyBooked: "Delvis bokad",
					declined: "Nekad",
					deleted: "Raderad",
					cancelled: "Avbruten",
				},
			},
			statusTypes: {
				options: {
					active: "Aktiv",
					inActive: "Inaktiv",
				},
			},
		},

		soldHourHelpText:
			"Bokade eller nekade timmar per uppdrag / skift.\nI första hand prioriteras fakturerad tid, i andra hand tidrapporterad och i tredje bokad/ beställd tid.\nI första hand används fakturerat timpris, i andra hand senaste fakturerade timpriset och i tredje hand timpriset vid bokningstillfället.\nRaderade uppdrag eller ej utförda skift från avbrutna uppdrag redovisas inte.",
	},

	invoice: {
		invoice: "Faktura",
		invoiceNumber: "Fakturanr",
		internalInvoiceNumber: "Underlagsnr",
		invoiceDate: "Fakturadatum",
		dueDate: "Förfallodatum",
		customer: "Kund",
		total: "Totalt",
		runInvoices: "New invoice batch", //TODO
		totalInclVat: "Totalt (inkl. moms)",
		totalExclVat: "Totalt (exkl. moms)",
		invoiceBatches: "Fakturakörningar",
		invoiceBatch: "Fakturakörning",
		description: "Beskrivning",
		quantity: "Antal",
		price: "À-pris",
		sum: "Summa",
		vat: "Moms",
		toPay: "Att betala",
		address: "Besöksadress",
		roundOff: "Öresutjämning",
		exclVat: "Exkl. moms",
		net: "Netto",
		downloadPdf: "Hämta PDF-faktura",
		createCredit: "Kreditera faktura",
		credited: "Krediterad",
		template: "Mall",
		timeReportsOnRow: "tidrapporter på raden",
		yourReference: "Er referens",
		costCenter: "Kostnadsställe",
		confirmDeleteRow: "Är du säker på att du vill ta bort fakturaraden?",
		downloading: "Hämtar faktura...",
		downloadFailed:
			"Kunde inte hämta PDF-faktura, säkerställ att fakturan existerar i fakturasystemet",
		credit: {
			credit: "Kreditfaktura",
			confirm: "Är du säker på att du vill skapa en kreditfakturan?",
			fortnoxInfo: "En kreditfaktura kommer skapas i Fortnox.",
			loading: "Skapar kreditfaktura...",
			failed: "Kunde inte skapa kreditfaktura",
			success: "Kreditfaktura #{{creditInvoiceNum}} skapades",
			invoiceNotBookKept: "Kan ej skapa kreditfaktura när fakturan ej är bokförd i Fortnox",
			invoiceAlreadyCredited: "Fakturan är redan markerad som krediterad i Fortnox",
		},

		journal: {
			pool: "Pool",
			numInvoices: "Antal fakturor",
			invoiceJournal: "Fakturajournal",
			to: "Till och med",
			invoiceDate: "Fakturadatum",
			invoiceNum: "Fakturanr",
			customer: "Kund",
			dueDate: "Förfallodatum",
			exclVAT: "Exkl. moms",
			inclVAT: "Inkl. moms",
			perService: "Per tjänst",
		},
	},

	/** Shared by the invoice and salary batch filters. */
	batchFilter: {
		/** Batch list column header. Shows the whole scoping, not just the pool. */
		scopeColumn: "Urval",
		/** "No constraint" row of the inline pool checkbox group. */
		allPools: "Alla",
		/** "No constraint" row of the inline subsidiary checkbox group. */
		allSubsidiaries: "Alla",
		noSubsidiary: "Ingen (direkt till organisationen)",
	},
	batchIssues: {
		showAll: "Visa alla ({{count}})",
		hide: "Dölj",
	},
	batchStaleness: {
		title: "Underlaget har ändrats",
		info: "Tidrapporterna har ändrats sedan förhandsgranskningen skapades ({{details}}). Uppdatera förhandsgranskningen för att räkna om den.",
		added_one: "{{count}} ny tidrapport",
		added_other: "{{count}} nya tidrapporter",
		changed_one: "{{count}} ändrad",
		changed_other: "{{count}} ändrade",
		removed_one: "{{count}} borttagen",
		removed_other: "{{count}} borttagna",
	},
	batchRefresh: {
		button: "Uppdatera förhandsgranskning",
		confirmDiscardEdits:
			"Manuella ändringar i utkastet (bortvalda rader och tillagda poster) går förlorade när förhandsgranskningen uppdateras. Vill du fortsätta?",
		success: "Förhandsgranskningen är uppdaterad",
		failed: "Kunde inte uppdatera förhandsgranskningen",
	},
	invoiceBatch: {
		invoiceBatches: "Fakturakörningar",
		invoiceBatch: "Fakturakörning",
		to: "Brytdatum",
		toDescription: "Tidrapporter till och med detta datum inkluderas i fakturakörningen",
		new: "Ny fakturakörning",
		newLikeThis: "Ny körning med samma urval",
		invoiceDateDescription: "Fakturadatum för respektive faktura som skapas i fakturakörningen",
		submit: "Förhandsgranska",
		issues: "",
		filter: {
			customerTags: "Kundtaggar",
			addTag: "Välj kundtagg",
			searchTag: "Sök kundtagg…",
			addContract: "Välj avtal",
			searchContract: "Sök avtal…",
			advanced: "Avancerat",
			customFields: "Anpassade fält",
			advancedSelection: "Avancerat urval",
			allPools: "Alla",
			customers: "Kunder",
			searchCustomer: "Sök kund…",
			excludedCustomers: "Exkluderade kunder",
			excludedCustomersCount_one: "{{count}} kund manuellt exkluderad",
			excludedCustomersCount_other: "{{count}} kunder manuellt exkluderade",
			selectedCustomers: "{{selected}} av {{total}} kunder valda · {{timeReports}} tidrapporter",
			timeReports_one: "{{count}} tidrapport",
			timeReports_other: "{{count}} tidrapporter",
			noCustomers: "Inga kunder matchar urvalet",
			readOnlySelection: "{{included}} kunder inkluderade · {{excluded}} manuellt exkluderade",
			excludedRow: "Manuellt exkluderad",
			done: "Klar",
		},
		scope: {
			heading: "Nuvarande urval:",
			customers_one: "{{count}} kund",
			customers_other: "{{count}} kunder",
			attestedTimeReports_one: "{{count}} attesterad tidrapport",
			attestedTimeReports_other: "{{count}} attesterade tidrapporter",
			empty: "Inga attesterade tidrapporter matchar ditt urval",
		},
		showInvoiceJournal: "Visa fakturajournal",
		cancel: "Ta bort",
		process: "Skapa fakturor",
		moreActions: "Fler alternativ",
		emptyState: {
			notSubmitted:
				"Välj datum för fakturakörning och tryck på 'Förhandsgranska' för att generera fakturaunderlag",
			noContent: "Det finns inget fakturaunderlag för angiven period",
		},
		error: {
			submit: "Något gick fel när fakturaunderlag skulle skapas",
			NOT_FOUND: "Det finns inga tidrapporter för angivet datum",
			INVOICE_BATCH_HAS_NO_CUSTOMERS:
				"Kunde inte skapa fakturakörning, det finns inga giltiga kunder",
			failedToRetrieve: "Något gick fel med att hämta fakturkörningen",
		},
		issue: "{{count}} problem upptäcktes",
		issueInfo:
			"Fakturor som är relaterade till nedastående fel har ej kunnat inkluderas i fakturakörningen:",
		warningsTitle_one: "{{count}} varning",
		warningsTitle_other: "{{count}} varningar",
		warningsInfo:
			"Följande har utelämnats ur fakturakörningen. Ej attesterade tidrapporter tas med i en senare körning när de attesterats:",
		issueType: {
			CUSTOMER_IS_INACTIVE: "Kund är ej aktiverad",
			CUSTOMER_IS_NOT_COMPLETED: "Kundprofilen saknar faktureringsuppgifter",
			TIME_REPORT_NOT_ATTESTED: "Tidrapport ej attesterad",
			INVALID_GLN_CODE: "Kundens GLN-kod är felaktig (ska vara 13 tecken)",
			DELIVERY_METHOD_INCOMPLETE: "Kundens leveranssätt saknar uppgifter",
			INVOICE_GENERATOR: "Fakturamallen hoppade över eller duplicerade tidrapporter",
			CUSTOMER_SKIPPED_BY_TEMPLATE: "Kunden lämnades utanför fakturakörningen",
			PREVIEW_ERROR: "Något gick fel när utkastet skapades",
		},
		issueDescription: {},
		skippedTimeReports_one: "{{count}} tidrapport väntar på nästa körning",
		skippedTimeReports_other: "{{count}} tidrapporter väntar på nästa körning",
		status: {
			INITIAL: "Utkast skapas",
			PREVIEW: "Utkast",
			ROLLED_BACK: "Avbruten",
			PROCESSED: "Genomförd",
			FAILED: "Felaktig",
			PROCESSING: "Pågående",
		},
		confirmRollback: "Är du säker på att du vill rulla tillbaka fakturakörningen?",
		confirmDelete: "Är du säker på att du vill ta bort fakturakörningen?",
		confirmRollbackAndRemove: "Är du säker på att du vill ta bort fakturakörningen?",
		rollbackAndRemoveSuccess: "Fakturakörningen togs bort",
		rollbackSuccess: "Fakturakörningen rullades tillbaka",
		rollbackFailed: "Kunde inte rulla tillbaka fakturakörningen",
		rollingBack: "Rullar tillbaka...",
		numInvoices: "Antal fakturor",
		showProcessingResult: "Detaljerad information om export (avancerat)",
		rollbackNotSupported:
			"Fakturakörningen kan inte rullas tillbaka eftersom fakturorna redan finns i Visma. Följ upp enskilda fakturor i stället.",
		exportSummary: {
			failed_one: "{{count}} misslyckad",
			failed_other: "{{count}} misslyckade",
			held_one: "{{count}} att kontrollera",
			held_other: "{{count}} att kontrollera",
			attachmentMissing_one: "{{count}} utan specifikation",
			attachmentMissing_other: "{{count}} utan specifikation",
		},
		exportBanner: {
			failed_one:
				"{{count}} faktura skapades inte i Visma. Tidrapporterna är släppta och kommer med i en ny fakturakörning.",
			failed_other:
				"{{count}} fakturor skapades inte i Visma. Tidrapporterna är släppta och kommer med i en ny fakturakörning.",
			held_one:
				"{{count}} faktura kan ha skapats i Visma. Kontrollera i Visma och ange utfallet nedan, tidrapporterna hålls kvar till dess.",
			held_other:
				"{{count}} fakturor kan ha skapats i Visma. Kontrollera i Visma och ange utfallet nedan, tidrapporterna hålls kvar till dess.",
			attachmentMissing_one:
				"{{count}} faktura saknar specifikation i Visma. Bifoga PDF:en manuellt i Visma.",
			attachmentMissing_other:
				"{{count}} fakturor saknar specifikation i Visma. Bifoga PDF:en manuellt i Visma.",
			released:
				"Tidrapporter från fakturor som inte skapades är släppta och kommer med i en ny fakturakörning.",
		},
		exportStatus: {
			column: "Status i Visma",
			FAILED: "Misslyckad",
			HELD: "Kontrollera i Visma",
			ATTACHMENT_MISSING: "Specifikation saknas",
			RELEASED: "Fanns inte i Visma",
			CONFIRMED_EXPORTED: "Finns i Visma",
			ATTACHMENT_RESOLVED: "Specifikation åtgärdad",
			resolvedAt: "Åtgärdad {{date}}",
			attachmentHelp: "Fakturan finns i Visma. Bifoga specifikationen (PDF) manuellt i Visma.",
			notInVisma: "Finns inte i Visma",
			inVisma: "Finns i Visma",
			markResolved: "Markera som åtgärdad",
			invoiceNumber: "Fakturanr {{invoiceNumber}}",
			releaseDialog: {
				title: "Fakturan finns inte i Visma",
				description:
					"Bekräfta att du har kontrollerat i Visma att fakturan till {{customer}} inte skapades. Tidrapporterna släpps och kommer med i nästa fakturakörning.",
				confirm: "Släpp tidrapporterna",
			},
			confirmDialog: {
				title: "Fakturan finns i Visma",
				description:
					"Ange fakturanumret som fakturan till {{customer}} fick i Visma. Fakturan markeras då som skapad.",
				invoiceNumber: "Fakturanummer i Visma",
				required: "Ange fakturanumret",
				confirm: "Spara",
			},
			success: {
				released: "Tidrapporterna är släppta",
				confirmed: "Fakturan är markerad som skapad i Visma",
				attachmentResolved: "Markerad som åtgärdad",
			},
			actionFailed: "Kunde inte spara. Ladda om sidan och försök igen.",
		},

		dryRun: {
			button: "Testkör",
			buttonHint:
				"Kontrollerar fakturakörningen mot fakturasystemet utan att skriva något. Inga fakturanummer tas i anspråk.",
			alreadyRunning: "En testkörning pågår redan för den här fakturakörningen",
			startFailed: "Kunde inte starta testkörningen",
			title: "Testkörning",
			running: "Testkörning pågår...",
			startedAt: "Startad {{date}}",
			ranAt: "Kördes {{date}}",
			ranAtBy: "Kördes {{date}} av {{name}}",
			outdated: "Inaktuell",
			outdatedInfo:
				"Fakturakörningen har ändrats efter testkörningen. Testkör igen för ett aktuellt resultat.",
			errorTitle: "Testkörningen kunde inte genomföras",
			errorInfo:
				"Kontrollen avbröts innan den var klar, så resultatet säger ingenting om fakturorna. Inget har skrivits till fakturasystemet. Försök igen.",
			resultErrors: "Testkörningen hittade fel",
			resultWarnings: "Testkörningen hittade varningar",
			resultClean: "Testkörningen hittade inga fel eller varningar",
			notAGuarantee:
				"En felfri testkörning är ingen garanti. Fakturasystemets egen kontroll görs först när fakturorna skapas.",
			invoicesChecked_one: "{{count}} faktura kontrollerad",
			invoicesChecked_other: "{{count}} fakturor kontrollerade",
			invoicesWithErrors_one: "{{count}} med fel",
			invoicesWithErrors_other: "{{count}} med fel",
			invoicesWithWarnings_one: "{{count}} med varningar",
			invoicesWithWarnings_other: "{{count}} med varningar",
			batchFindings: "Gäller hela fakturakörningen",
			invoiceFindings: "Per faktura",
			severity: {
				error: "Fel",
				warning: "Varning",
			},
			showInvoice: "Visa i listan",
			showDetails: "Visa detaljer",
			hideDetails: "Dölj detaljer",
			tenant: "Bolag {{tenantId}}",
			plannedWrites: "Skulle skrivas till fakturasystemet",
			customersToCreate_one: "{{count}} kund skapas",
			customersToCreate_other: "{{count}} kunder skapas",
			customersToUpdate_one: "{{count}} kund uppdateras",
			customersToUpdate_other: "{{count}} kunder uppdateras",
			changedFields: "Ändras: {{fields}}",
			articlesToCreate_one: "{{count}} artikel skapas",
			articlesToCreate_other: "{{count}} artiklar skapas",
			subaccountsToCreate_one: "{{count}} underkonto skapas",
			subaccountsToCreate_other: "{{count}} underkonton skapas",
			notChecked: "Kunde inte kontrolleras",
			rowMarker: {
				error: "Testkörningen hittade fel på fakturan",
				warning: "Testkörningen hittade varningar på fakturan",
			},
			confirmProcess:
				"Den senaste testkörningen hittade fel. Fakturor med fel kan avvisas av fakturasystemet eller stoppa körningen. Vill du ändå skapa fakturorna?",
			processingModal: {
				loading: "Testkör fakturakörningen...",
				loadingInfo:
					"Läser från fakturasystemet och kontrollerar fakturorna. Inget skrivs och inga fakturanummer tas i anspråk. Det kan ta några minuter beroende på antal fakturor.",
				done: "Testkörningen är klar",
				doneInfo: "Resultatet visas ovanför fakturorna.",
				failure: "Testkörningen kunde inte genomföras",
			},
		},

		processingModal: {
			loading: "Skapar fakturor...",
			loadingInfo:
				"Anropar fakturasystem. Detta kan ta upp till några minuter beroende på mängd fakturor i fakturakörning.",
			failure: "Fakturakörningen kunde ej genomföras",
			processed: "Fakturakörningen genomfördes",
			log: "Visa loggutskrifter ({{count}})",
			createdCustomers: "{{count}} kunder skapades",
			updatedCustomers: "{{count}} kunder uppdateras",
			processingWarnings: "Visa varningar ({{count}})",
			partial: "Fakturakörningen genomfördes med avvikelser",
			partialInfo: "Följande fakturor behöver följas upp:",
			showBatch: "Visa fakturakörningen",
		},
	},

	salary: {
		submitFailure: "Kunde inte hämta löneunderlag för perioden",
		submitFailure404: "Det finns inga tidrapporter för perioden",
		creatingPreview: "Skapar löneunderlag...",
		previewReady: "Löneunderlaget är klart",
		previewFailed: "Kunde inte skapa löneunderlag",
		start: "Startdatum",
		end: "Slutdatum",
		breakdown: {
			hourly: "Timlön",
			holidayPay: "Semesterersättning",
			childCare: "VAB",
			sickPay: "Sjuklön dag 1-14",
			sickPayNonPaid: "Sjukdag 15-",
			qualifyingDeduction: "Karensavdrag",
			leaveOfAbsence: "Tjänstledighet",
		},
		journal: {
			all: "Alla",
			quantity: "Antal",
			award: "Pris",
			amount: "Belopp",
			numberOfPeople: "Antal personer",
			salaryPeriod: "Löneperiod",
			salaryJournal: "Lönejournal",
			byTypeOfSalary: "Per löneart",
			noData: "Det finns ingen data",
			print: "Skriv ut",
			salaryTypes: {
				hourly: "Timlön",
				holidayPay: "Semesterersättning",
				deduction: "Avdrag*",
				sickPay: "Sjuklön dag 1-14",
				sickPayNonPaid: "Sjukdag 15-",
				qualifyingDeduction: "Karensavdrag",
				leaveOfAbsence: "Tjänstledighet",
				childCare: "VAB",
				ob: "OB",
				ob1: "OB1",
				ob2: "OB2",
				ob3: "OB3",
				ob4: "OB4",
				ob5: "OB5",
			},
		},
		hourlyPay: "Timlön",
		ob: "OB-tillägg",
		qualifyingDeduction: "Karensavdrag",
		grossSalary: "Bruttolön (före skatt)",
		sickPay: "Sjuklön",
		totalHours: "Total utbokad tid",
	},

	salaryBatch: {
		success: {
			fortnox: "Konsulter och löner har överförts till Fortnox",
			hogia: "Lönefilen och personregister har skapats",
		},
		issue: "{{count}} problem upptäcktes",
		issueInfo: "Löner som berör nedastående problem har ej inkluderats i lönekörningen:",
		warningsTitle_one: "{{count}} varning",
		warningsTitle_other: "{{count}} varningar",
		warningsInfo: "Följande har utelämnats ur lönekörningen:",
		issueType: {
			MISSING_CONSULTANT_BANK_DETAILS: "Konsult saknar eller har felaktiga bankuppgifter",
			MISSING_CONSULTANT_SALARY_DETAILS: "Konsult saknar en eller flera löneuppgifter",
			TIME_REPORT_NOT_ATTESTED: "Tidrapport är ej attesterad",
			INVALID_PERSONAL_NUMBER:
				"Felaktigt personnummer, måste vara ett giltigt svenskt personnummer",
			PREVIEW_ERROR: "Något gick fel när utkastet skapades",
		},
		status: {
			INITIAL: "Skapar",
			PREVIEW: "Utkast",
			ROLLED_BACK: "Avbruten",
			PROCESSED: "Genomförd",
			FAILED: "Felaktig",
			PROCESSING: "Pågående",
		},
		processingModal: {
			loading: "Skapar löner...",
			loadingInfo: "Detta kan ta upp till några minuter beroende på mängd löner.",
			failure: "Lönekörningen kunde ej genomföras",
			processed: "Lönekörningen genomfördes",
			log: "Visa loggutskrifter ({{count}})",
			createdEmployees: "{{count}} konsulter skapades i personalregistret",
			updatedEmployees: "{{count}} konsulter uppdateras i personalregistret",
			processingWarnings: "Visa varningar ({{count}})",
		},
	},

	timeReports: {
		selectedRows: "{{count}} rad",
		selectedRows_plural: "{{count}} rader",
		updateSuccess: "Tidrapporten uppdaterades",
		bulkAttest: {
			attest: "Attestera",
			info: "Vill du attestera {{count}} tidrapport(er)?",
			warning:
				"OBS! En eller flera av de markerade tidrapporterna är ej redo att attesteras och kommer därmed inte ändras",
			loading: "Attesterar {{count}} tidrapport(er)",
			success: "Tidrapporterna attesterades",
			partial: "{{updated}} attesterades, {{failed}} kunde inte attesteras",
			error: "Tidrapporterna kunde inte attesteras",
		},
		bulkPublish: {
			publish: "Publicera",
			info: "Vill du publicera {{count}} tidrapport(er)?",
			warning:
				"OBS! En eller flera av de markerade tidrapporterna är ej redo att publiceras och kommer därmed inte ändras",
			loading: "Publicerar {{count}} tidrapport(er)",
			success: "Tidrapporterna publicerades",
		},
		reportedTimeHelp:
			"Tid som konsulten har rapporterat att hen arbetat. Används vid beräkning av lön.",
		billedTimeHelp:
			"Tid som kommer faktureras till kund. Denna tid kommer INTE ligga till grund för lön. Om inget annat anges är denna tid samma som Arbetad tid.",
		billableTime: "debiterad tid",
		selectDateRange: "Välj datum",
		listStatus: {
			SICK_LEAVE: "Sjukfrånvaro",
			LEAVE_OF_ABSENCE: "Tjänstledig",
			CHILD_CARE: "VAB",
		},
		pendingPublish: "Ej publicerad",
		publish: "Publicera till kund",
		undoResolve: "Ångra hanterad",
	},

	absence: {
		reason: "Frånvaroorsak",
		type: {
			SICK_LEAVE: "Sjukfrånvaro",
			CHILD_CARE: "VAB",
			LEAVE_OF_ABSENCE: "Tjänstledig",
		},
		delete: {
			title: "Ta bort frånvaro",
			text: "Är du säker på att du vill ta bort frånvaron?",
			warning: {
				title: "Frånvaro används i lön/faktura",
				text: "Denna frånvaro har tidrapporter som redan är lönebehandlade eller fakturerade. Vill du ändå ta bort frånvaron?",
				confirm: "Ta bort ändå",
			},
		},
	},

	recruitment: {
		sendMessage: {
			subject: "Ämne",
			message: "Ange meddelande här",
			success: "Meddelandet har skickats",
		},
		moveToConsultantPool: {
			confirmationText: "Är du säker på att du vill lägga upp kandidaten som konsult?",
			cancel: "Avbryt",
			yes: "Ja",
		},
		sendContractModal: {
			title: "Är du säker på att du vill skicka avtalet?",
			text: "Anställningsavtalet kommer skickas till kandidaten för signering. Välj hur du vill skicka inbjudan till att signera.",
			emailLabel: "Skicka via e-post till {{email}}",
			smsLabel: "Skicka via SMS till {{phoneNo}}",
			success: "Avtalet har skickats",
			missingDetails:
				"Kandidat måste ha personnummer och löneuppgifter angivna för att kunna skicka avtal.",
		},
		adId: "Annons",
		removeCandidate: "Ta bort kandidat",
		created: "Kandidaten skapades",
		otherNotes: "Övriga rekryteringsanteckningar",
		bulk: {
			selected: "kandidater valda",
			recipients: "kandidater",
			sendMessage: "Skicka meddelande",
			updateAction: "Ändra aktivitet",
			clearSelection: "Avmarkera alla",
		},
	},

	customers: {
		user: {
			errors: {
				cannotDeleteLast: "Det måste alltid finnas minst en användare på kunden.",
			},
			autoComplete: {
				placeholder: "Sök användare att lägga till",
			},
			noUsers: "Kund saknar användare",
			confirmAdd: {
				title: "Är du säker på att du vill lägga till användaren?",
				text: "Användaren kommer kunna logga in och beställa å kundens vägnar.",
			},
		},
		customerNumberShort: "Kundnr",
		multipleCustomers: {
			access: "Användare har åtkomst till flera kunder",
			name: "Namn",
			customerNumber: "Kundnummer",
			notifications: "Notifieringar",
			addCustomer: "Lägg till",
			cancel: "Avbryt",
			noCustomers: "Hittade inga kunder",
			notificationTypes: {
				booking: "Bokningsbekräftelse via e-post",
				timeReport: "Notifieringar om tidrapporter",
				jobReport: "Arbetsrapport",
			},
			errors: {
				emptyCustomer: "Please select a customer",
			},
			add: "Lägg till kund",
			info: "Hantera vilka kunder som användaren har tillgång till samt notisinställningar för dessa.",
			notificationSettingsTitle: "Notisinställning",
		},
	},

	sendNotificationModal: {
		title: "Notifiera konsulter",
		info: "Ange meddelande som skickas till konsulter som matchar uppdraget. Meddelandet skickas som push-notis till konsultens mobilapp.",
		placeholder: "max 200 tecken",
		success: "Meddelandet skickades",
	},

	eventTimeline: {
		noEvents: "Inga händelser registrerade ännu.",
		system: "System",
		via: "via {{channel}}",
		channelLabel: {
			"ai-assistant": "AI-assistenten",
		},
		changed: "ändrades",
		updated: "uppdaterat",
		deletedSuffix: "(borttaget)",
		loadError: "Kunde inte hämta händelser",
		showMore: "Visa fler händelser",
		showMoreBody: "Visa mer",
		showLessBody: "Visa mindre",
		yes: "Ja",
		no: "Nej",
		channel: {
			push: "push",
			mail: "e-post",
			sms: "SMS",
		},
		event: {
			UNKNOWN: "Händelse",
		},
		consultant: {
			event: {
				CONSULTANT_CREATED: "Konsulten skapades",
				CONSULTANT_UPDATED: "Konsulten uppdaterades",
				CONSULTANT_ACTIVATED: "Konsulten aktiverades",
				CONSULTANT_DEACTIVATED: "Konsulten avaktiverades",
				CONSULTANT_BLOCKED: "Blockerad för kund {{name}}",
				CONSULTANT_UNBLOCKED: "Avblockerad för kund {{name}}",
				SALARY_CHANGED: "Lön ändrades",
				TAG_ADDED: "Tagg lades till: {{name}}",
				TAG_REMOVED: "Tagg togs bort: {{name}}",
				TAG_EXPIRED: "Taggen gick ut: {{name}}",
				TAG_RENEWED: "Taggen förnyades: {{name}} – gäller till {{to}}",
				CERTIFICATION_ADDED: "Certifikat lades till: {{name}}",
				CERTIFICATION_REMOVED: "Certifikat togs bort: {{name}}",
				CERTIFICATION_EXPIRY_CHANGED:
					"Certifikatet {{name}} gäller nu t.o.m. {{to}} (tidigare {{from}})",
				COMPETENCE_ADDED: "Kompetens lades till: {{name}}",
				COMPETENCE_REMOVED: "Kompetens togs bort: {{name}}",
				COMPETENCE_SUPPLEMENT_CHANGED: "Tillägg ändrades för {{name}}: {{from}} → {{to}}",
				DOCUMENT_ADDED: "Dokument lades till: {{name}}",
				DOCUMENT_UPDATED: "Dokument uppdaterades: {{name}}",
				DOCUMENT_REMOVED: "Dokument togs bort: {{name}}",
				MANAGER_TRANSFERRED: "Konsultchef ändrades: {{from}} → {{to}}",
				RECRUITED: "Anställdes som konsult",
				EMPLOYMENT_STARTED_SET: "Anställningsdatum sattes vid första bokningen",
				EMPLOYMENT_CERTIFICATE_SENT: "Arbetsgivarintyg skickades",
				PASSWORD_SET: "Lösenord sattes av administratör",
				// "Skickat", aldrig "levererat" — vi ser bara att meddelandet
				// lämnades över till push-/mail-/SMS-leverantören.
				NOTIFICATION_SENT: "Meddelande skickat – {{name}}{{channels}}",
			},
			fields: {
				firstName: "Förnamn",
				lastName: "Efternamn",
				email: "E-post",
				profile_phoneNumber: "Telefonnummer",
				profile_title: "Titel",
				profile_pool: "Pool",
				profile_subsidiaryId: "Dotterbolag",
				profile_ou1: "Organisationsenhet 1",
				profile_ou2: "Organisationsenhet 2",
				profile_socialSecurityNumber: "Personnummer",
				profile_internalNotes: "Interna anteckningar",
				profile_confidentialInfo: "Konfidentiell information",
				profile_icePhone: "Anhörig, telefon",
				profile_iceName: "Anhörig, namn",
				profile_address_address1: "Adress",
				profile_address_address2: "Adress 2",
				profile_address_postalCode: "Postnummer",
				profile_address_city: "Ort",
				profile_bank_name: "Bank",
				profile_bank_accountNumber: "Kontonummer",
				profile_bank_clearingNumber: "Clearingnummer",
				profile_employment_started: "Anställd från",
				profile_employment_ended: "Anställd t.o.m.",
				profile_employment_title: "Anställningstitel",
				profile_employment_union: "Fackförbund",
				profile_employment_employmentOption: "Anställningsform",
				profile_employment_colAgreement_id: "Kollektivavtal",
			},
		},
		customer: {
			event: {
				CUSTOMER_CREATED: "Kunden skapades",
				CUSTOMER_UPDATED: "Kunden uppdaterades",
				CUSTOMER_ACTIVATED: "Kunden aktiverades",
				CUSTOMER_DEACTIVATED: "Kunden avaktiverades",
				CUSTOMER_DELETED: "Kunden togs bort",
				CONTRACT_CHANGED: "Avtal ändrades: {{from}} → {{to}}",
				SUBSIDIARY_CHANGED: "Dotterbolag ändrades: {{from}} → {{to}}",
				TAG_ADDED: "Tagg lades till: {{name}}",
				TAG_REMOVED: "Tagg togs bort: {{name}}",
				USER_ADDED: "Användare lades till: {{name}}",
				USER_REMOVED: "Användare togs bort: {{name}}",
				DELIVERY_STATE_SET_BY_FORTNOX: "{{deliveryLabel}}",
			},
			fields: {
				name: "Namn",
				customerNumber: "Kundnummer",
				vatNumber: "Momsregistreringsnummer",
				phoneNumber: "Telefonnummer",
				description: "Beskrivning",
				directions: "Vägbeskrivning",
				internalNotes: "Interna anteckningar",
				ou1: "Organisationsenhet 1",
				ou2: "Organisationsenhet 2",
				pool: "Pool",
				resultUnit: "Resultatenhet",
				privatePerson: "Privatperson",
				breakTime: "Rast",
				corporateGroup_id: "Koncern",
				visitingAddress_address1: "Besöksadress",
				visitingAddress_address2: "Besöksadress 2",
				visitingAddress_postalCode: "Postnummer",
				visitingAddress_city: "Ort",
				visitingAddress_country: "Land",
				invoiceDetails_invoiceName: "Fakturanamn",
				invoiceDetails_GLNCode: "GLN-kod",
				invoiceDetails_address1: "Fakturaadress",
				invoiceDetails_address2: "Fakturaadress 2",
				invoiceDetails_postalCode: "Postnummer (faktura)",
				invoiceDetails_city: "Ort (faktura)",
				invoiceDetails_country: "Land (faktura)",
				invoiceDetails_reference: "Referens",
				invoiceDetails_costCenter: "Kundens kostnadsställe",
				invoiceDetails_email: "E-post (faktura)",
				invoiceDetails_deliveryMethod: "Leveranssätt",
				invoiceDetails_deliveryManagedBy: "Styrs av",
			},
		},
	},

	jobTimeline: {
		noEvents: "Det finns inga händelser för det här uppdraget ännu.",
		system: "System",
		consultantFallback: "Konsulten",
		loadError: "Kunde inte hämta händelser",
		changed: "ändrades",
		event: {
			JOB_CREATED: "Uppdraget skapades",
			JOB_UPDATED: "Uppdraget uppdaterades",
			JOB_CANCELED: "Uppdraget avbokades",
			JOB_DELETED: "Uppdraget togs bort",
			JOB_DENIED: "Uppdraget nekades",
			JOB_REOPENED: "Uppdraget återöppnades",
			JOB_STATUS_CHANGED: "Status ändrades: {{from}} → {{to}}",
			APPLICATION_CREATED: "{{consultant}} ansökte om uppdraget",
			ACCEPTED_APPLICATION_CREATED: "{{consultant}} bokades på uppdraget",
			APPLICATION_ACCEPTED: "Ansökan från {{consultant}} accepterades",
			APPLICATION_DECLINED: "Ansökan från {{consultant}} nekades",
			APPLICATION_DELETED: "Ansökan från {{consultant}} togs bort",
			APPLICATION_CANCELLED: "{{consultant}} avbröt sin ansökan",
			APPLICATIONS_CANCELLED_OVERLAP:
				"Ansökan från {{consultant}} avbröts eftersom konsulten bokades på ett annat uppdrag",
			INVITATION_CREATED: "{{consultant}} bjöds in till uppdraget",
			INVITATION_UPDATED: "Inbjudan till {{consultant}} uppdaterades",
			INVITATION_DECLINED: "{{consultant}} tackade nej till inbjudan",
			INVITATION_DELETED: "Inbjudan togs bort",
			INVITATION_ACCEPTED: "{{consultant}} tackade ja till inbjudan",
			INVITATIONS_DELETED_OVERLAP:
				"Inbjudan till {{consultant}} togs bort eftersom konsulten bokades på ett annat uppdrag",
			INVITATION_EXPIRED: "Inbjudan till {{consultant}} förföll",
			SHIFT_ADDED: "Arbetspass lades till",
			SHIFT_UPDATED: "Arbetspass ändrades",
			SHIFT_REMOVED: "Arbetspass togs bort",
			TIME_REPORT_REPORTED: "Tidrapport rapporterades",
			TIME_REPORT_ATTESTED_BY_ADMIN: "Tidrapport attesterades internt",
			TIME_REPORT_ATTESTED_BY_CUSTOMER: "Tidrapport attesterades av kund",
			TIME_REPORT_SILENT_ATTESTED: "Tidrapport attesterades automatiskt",
			TIME_REPORT_INVOICED: "Tidrapport fakturerades",
			TIME_REPORT_UNDO: "Tidrapport återställdes",
			UNKNOWN: "Händelse",
		},
		status: {
			OPEN: "Öppet",
			BOOKED: "Bokat",
			BOOKED_WITH_UNMANNED_SHIFTS: "Bokat med obemannade pass",
			DECLINED: "Nekat",
			CANCELLED: "Avbokat",
			DELETED: "Borttaget",
		},
		fields: {
			description: "Beskrivning",
			customerDescription: "Beskrivning till kund",
			internalNotes: "Interna anteckningar",
			contactPersons: "Kontaktpersoner",
			competence: "Kompetens",
			pool: "Pool",
			tags: "Taggar",
			requirements: "Krav",
			hidden: "Dolt",
			flag: "Flagga",
			address: "Adress",
			numPositions: "Antal platser",
			bookingType: "Bokningstyp",
			price: "Pris",
			noOfHours: "Antal timmar",
			noOfDays: "Antal dagar",
			startDate: "Startdatum",
			endDate: "Slutdatum",
			status: "Status",
			start: "Starttid",
			end: "Sluttid",
			break: "Rast",
			flexible: "Flexibel starttid",
			documents: "Dokument",
			videos: "Videor",
			customerOrderNumber: "Kundens beställningsnummer",
			purchaseOrderNo: "Inköpsordernummer",
			invoiceReference: "Fakturareferens",
			source: "Källa",
			taxDeduction: "RUT/ROT",
			isLongTerm: "Långtid",
			contract: "Avtal",
			allowLaterBooking: "Tillåt senare bokning",
		},
	},

	shiftCal: {
		selectWeek: "Markera mån-fre",
		deselectWeek: "Avmarkera vecka",
	},

	organisation: {
		notifications: {
			push: "Pushnotis",
			email: "E-post",
			emailTemplate: "E-postmall",
			emailTemplateDesc: "Sendgrid template ID",
			pushDesc: "Maxlängd ca 150 tecken",
			editTemplate: "Redigera",
			emailLayout: "E-postlayout",
			emailLayoutDesc: "Mall som används som bas för alla e-postutskick",
			emailSubject: "Ämnesrad",
			sendTest: "Skicka test",
			sendTestModalTitle: "Skicka test",
			sendTestDescription: "Ange en e-postadress för att skicka en testnotis.",
			userEmailPlaceholder: "E-postadress",
			templatePreview: "Mallförhandsvisning:",
			testSent: "Testnotis skickad",
			userNotFound: "Användare hittades inte. Kontrollera e-postadressen.",
		},
		economy: {
			cfar: "CFAR-nummer",
			cfarDescription:
				"CFAR-nummer som anges vid lönekörning. Lämna tomt om inget CFAR-nummer ska anges.",
			cfarUpdated: "CFAR-nummer uppdaterades",
		},
		defaultContract: {
			updated: "Standardavtalet uppdaterades",
		},
		subsidiaries: {
			title: "Dotterbolag",
			description:
				"Hantera organisationens dotterbolag. Du kan knyta kunder och konsulter till dotterbolag.",
			add: "Lägg till dotterbolag",
			edit: "Redigera dotterbolag",
			empty: "Inga dotterbolag har lagts till ännu.",
			name: "Namn",
			orgNo: "Organisationsnummer",
			address1: "Adress",
			careOf: "C/O",
			postalCode: "Postnummer",
			city: "Ort",
			cfar: "CFAR-nummer",
			cfarDescription: "CFAR-nummer för dotterbolaget.",
			recruitmentContract: "Anställningsavtal (mall)",
			recruitmentContractDescription:
				"Handlebars-mall som ersätter organisationens mall när en konsult i detta dotterbolag anställs. Lämna tomt för att använda organisationens mall.",
			pools: "Pooler",
			poolsDescription:
				"Pooler som är tillgängliga för dotterbolagets konsulter (en delmängd av organisationens pooler). Lämna tomt för att tillåta alla organisationens pooler.",
			deleteConfirmTitle: "Ta bort dotterbolag",
			deleteConfirm: "Är du säker på att du vill ta bort detta dotterbolag?",
			deleteBlocked:
				"Dotterbolaget kan inte tas bort så länge konsulter eller kunder är kopplade till det.",
			deleted: "Dotterbolaget togs bort",
		},
	},

	customerBlock: {
		comment: "Intern kommentar",
	},

	schedule: {
		schedule: "Kalender",
		byConsultant: "Konsultöversikt",
		byCustomer: "Kundöversikt",
		selectDateRange: "Välj period",
		filterConsultant: "Konsult",
		filterConsultantManager: "Konsultchef",
		filterCustomer: "Kund",
		filterContract: "Avtal",
		includeUnbooked: "Visa konsulter som inte är bokade",
	},

	datePicker: {
		time: "Klockslag",
		timePlaceholder: "hh:mm",
		select: "Välj datum",
		timeShortcuts: "Snabbval",
	},

	inviteModal: {
		title: "Bjud in {{name}}",
		text: "Användaren kommer att få ett inbjudningsmail och/eller SMS med en länk till ett formulär där denne kan ange sitt lösenord och instruktioner om hur man kommer igång.",
		success: "Inbjudan har skickats",
		failure: "Något gick fel, vänligen försök igen",
	},

	error: {
		DELIVERY_METHOD_INCOMPLETE: "Leveranssättet saknar uppgifter",
		DELIVERY_MANAGED_BY_FORTNOX:
			"Leveranssätt och GLN-kod styrs av Fortnox och kan inte ändras i Origo",
		INVALID_GLN_CODE: "GLN-kod måste vara exakt 13 siffror",
		ACCEPTED_CONSULTANT_SHIFT_OVERLAP:
			"Ett eller flera arbetspass överlappar med annat uppdrag som konsulten är bokad på",
		HAS_WORKED_SHIFT: "Det går inte att redigera arbetspass när arbetet har påbörjats",
		LAST_USER_OF_CUSTOMER_CANNOT_UPDATE:
			"Kan ej ta bort användare, en kund måste ha minst en användare",
		PRICE_CANNOT_CALCULATE: "Kan ej beräkna pris för den angivna kompetensen",
		ORDER_NUMBER_ALREADY_EXISTS: "Ordernumret finns redan",
		CONSULTANT_IS_INACTIVE: "Konsulten är ej aktiverad",
		CONSULTANT_NOT_AVAILABLE: "Konsulten är inte längre tillgänglig för uppdraget",
		INVALID_SOCIAL_SECURITY_NUMBER:
			"Konsulten saknar ett giltigt personnummer. Avtalet låses till konsultens personnummer för signering — kontrollera och korrigera personnumret i profilen.",
		BAD_REQUEST: "Något gick fel (400)",
		SCHEDULE_CONFLICT: "Konsulten är redan bokad på annat uppdrag som överlappar med detta",
		ABSENCE_HAD_USED: "Tidrapport(er) har fakturerats eller använts för löneberäkning",
		MISSING_POLICE_EXTRACT:
			"Kan inte boka — konsulten saknar giltigt belastningsutdrag för denna bransch",
	},

	consultantTag: {
		hoursLeft: "{{count}} h kvar",
		renew: "Förnya ({{hours}} h)",
		remove: "Ta bort",
	},

	contactMenu: {
		call: "Ring {{phone}}",
		callShort: "Ring",
		message: "Skicka meddelande",
		gotoProfile: "Visa profil",
		gotoCustomer: "Visa kund",
		gotoJob: "Visa uppdrag",
		createJob: "Skapa uppdrag",
		settings: "Inställningar",
		tags: "Taggar",
		contactPersons: "Kontaktpersoner",
		noContactPersons: "Inga kontaktpersoner",
		noContactDetails: "Kontaktuppgifter saknas",
		copyPhone: "Kopiera telefonnummer",
		copyEmail: "Kopiera e-post",
		copied: "Kopierat",
	},

	jobReport: {
		ratingNotSet: "Ej satt",
		period: "Period",
	},

	updateToast: {
		title: "Det finns en ny version av Origo.",
		description: "Tryck på knappen för att uppdatera.",
		button: "Ladda om",
	},
	effortRating: "Arbetsinsats",
	punctualityRating: "Punktlighet",
	showConsultants: "Visas för konsulter inom",
	publishDocuments: "Publicera dokument",
	updateDocuments: "Uppdatera dokument",
	LINK: "Länk",
	ADD_LINK: "+ Lägg till länk",
	UPLOAD_FILE: "+ Ladda upp fil",
	UPLOAD_FILE_TITLE: "Ladda upp fil",
	EDIT_FILE_TITLE: "Redigera fil",
	UPLOAD_LINK_TITLE: "Lägg till länk",
	UPLOAD_LINK_EDIT_TITLE: "Redigera länk",
	VIEW_IN_CONSULTANT_APP: "Visa i konsultapp",
	DELETE: "Radera",
	DOCUMENT_TYPE_DOCUMENT: "DOKUMENT",
	DOCUMENT_TYPE_LINK: "LÄNK",
	DOCUMENT_DELETED_SUCCESS: "Dokumentet har raderats",
	DOCUMENT_DELETE_FAILED: "Det gick inte att radera dokumentet",
	FILE_OR_LINK: "Fil / Länk",
	TYPE: "Typ",
	ACTIONS: "Åtgärder",
	jobReportFeedback: {
		deleteMessageTitle: "Radera omdöme",
		deleteMessageText: "Är du säker på att du vill radera detta omdöme? Åtgärden kan inte ångras.",
		deleted: "Raderat",
	},
	otp2FA: {
		formSectionTitle: "Tvåfaktorsinloggning",
		formEnableLabel: "Aktivera tvåfaktorsinloggning via SMS för användaren",
		formOrganisationRequiresHint:
			"Organisationen kräver tvåfaktorsinloggning via SMS för alla användare (Inställningar → Organisation → Säkerhet). Inloggning kräver därför alltid en SMS-kod oavsett valet ovan, och användaren måste ha ett mobilnummer.",
		otpEmptyErrorMessage: "Du måste ange en kod för att fortsätta.",
		otpErrorMessage: "Felaktig kod. Försök igen.",
		enable2FA: "Aktivera tvåfaktorsinloggning med SMS",
		enable2FAMessage:
			"Vi skickar en engångskod till det angivna telefonnumret. Ange koden i nästa steg för att aktivera tvåfaktorsinloggning.",
		sendCode: "Skicka kod",
		cancel: "Avbryt",
		enterCode: "Ange din kod",
		confirm: "Bekräfta",
		resendCodeMessage: "Skicka om engångskoden om",
		second: "sekunder",
		resendCodeRemaining: "Fick du inte någon kod?",
		sendNewCode: "Klicka här för att skicka en ny",
		enabled2FA: "Tvåfaktorsinloggning är aktiverad!",
		enabled2FAMessage:
			"Nästa gång du loggar in behöver du ange en engångskod som skickas till ditt mobilnummer.",
		close: "Stäng",
		loginScreenMessage:
			"Tvåfaktorsinloggning är aktiverad för ditt konto. En engångskod har skickats till din mobil, ange koden i SMS:et nedan för att slutföra inloggningen.",
	},
	DOCUMENTS_TITLE: "Bibliotek",
	DOCUMENT_PUBLISH_ERROR: "Dokumentet kunde ej sparas",
	DOCUMENT_FILL_IN_MESSAGE: "Vänligen fyll i alla uppgifter",
	DOCUMENT_PUBLISHED_MESSAGE: "Dokumentet publicerades",
	DOCUMENT_UPDATE_MESSAGE_ERROR: "Dokumentet kunde inte uppdateras",
	DOCUMENT_UPDATE_MESSAGE_SUCCESS: "Dokumentet uppdaterades",
	notificationTags: {
		recruitment: "Rekrytering",
		onboarding: "Onboarding",
		timereports: "Tidrapporter",
		availability: "Tillgänglighet",
		confirmations: "Bekräftelser",
		matching: "Matchning & Bokning",
		allTemplates: "Alla mallar",
		uncategorized: "Okategoriserade",
	},
	TRANSFER_CONSULTANTS: "Överför konsulter",
	TRANSFER_CONSULTANTS_TITLE: "Överför konsulter till ny chef",
	TRANSFER_CONSULTANTS_SELECT_MANAGER: "Välj ny konsultchef",
	TRANSFER_CONSULTANTS_COUNT: "{{count}} konsulter kommer att överföras",
	TRANSFER_CONSULTANTS_CONFIRM: "Bekräfta överföring",
	TRANSFER_CONSULTANTS_SUCCESS: "{{count}} konsulter överfördes",
	TRANSFER_CONSULTANTS_PARTIAL:
		"{{success}} av {{total}} konsulter överfördes. {{failed}} misslyckades.",
	TRANSFER_CONSULTANTS_CANCEL: "Avbryt",
	TRANSFER_CONSULTANTS_NO_MANAGERS: "Inga andra konsultchefer tillgängliga i denna organisation",

	shiftPlanner: {
		firstShift: "Första passet",
		today: "Idag",
		lastShift: "Sista passet",
		daysUnit: "dagar",
		hoursUnit: "timmar",
		timeReports: "Tidrapporter",
		timeReportsHint: "Uppdragets alla tidrapporter",
		noTimeReports: "Inga tidrapporter ännu",
		openTimeReports: "Öppna i Tidrapporter (ny flik)",
		clearAll: "Rensa alla pass",
		week: "Vecka {{week}}, {{month}}",
		weekShort: "v.{{week}} {{month}}",
		selectConsultant: "Välj konsult",
		unmanned: "Obemannad",
		addDemand: "Lägg till behov",
		assignOrInvite: "Boka eller önska konsult",
		searchConsultant: "Sök konsult…",
		noMatchingConsultants: "Inga matchande konsulter",
		searchConsultants: "Sök namn, anställningsnr eller personnr",
		overlapTargets: "Markerade pass överlappar varandra",
		invite: "Önska",
		availability: {
			full: "Tillgänglig enligt schema",
			partial: "Delvis tillgänglig enligt schema",
			none: "Ej tillgänglig enligt schema",
			unknown: "Tillgänglighet okänd",
		},
		demandDayCount: "{{count}} dagar",
		demandCount: "Antal konsulter",
		expandGroup: "Visa passen var för sig",
		collapseGroup: "Gruppera identiska pass",
		matchConsultant: "Matcha konsult",
		pickThisWeek: "Endast denna vecka ({{count}} pass)",
		pickAllWeeks: "Alla veckor ({{count}} pass)",
		menuBook: "Boka konsult",
		menuInvite: "Önska konsult",
		changeTimes: "Ändra tider",
		duplicate: "Duplicera",
		repeat: "Repetera",
		repeatWeekdays: "Vardagar samma vecka",
		repeatWholeWeek: "Alla dagar samma vecka",
		repeatNextWeek: "Samma dag nästa vecka",
		repeatFourWeeks: "Samma dag 4 veckor framåt",
		demandAdd: "Lägg till",
		changeConsultant: "Byt konsult",
		unassignConsultant: "Ta bort konsult (behåll passen)",
		selectedShifts: "{{count}} markerade pass",
		change: "Ändra",
		fromTo: "Från - Till",
		breakHours: "Rast (tim)",
		breakHint: "Om ej satt kommer rast ej räknas ut enligt regelverk.",
		breakShort: "{{hours}} h rast",
		close: "Stäng (Esc)",
		done: "Klar",
		showMore: "Visa fler ({{count}})",
		removeLane: "Ta bort rad",
		showRows: "Visa rader",
		hideRows: "Dölj rader",
		overlapAlert:
			"{{name}} har redan ett pass som överlappar ({{date}}, {{times}}). Ändra tiderna eller välj en annan konsult.",
		removeShift: "Ta bort pass",
		absence: "Frånvaro",
		applied: "Ansökt",
		invited: "Önskad",
		pendingDetails: "Ansökningar & önskningar",
		acceptApplication: "Boka",
		removeInvitation: "Ta bort önskan",
		help: "Hjälp",
		reportedTimeEdited:
			"Ett eller flera pass med rapporterad tid ändras. Kontrollera ändringarna — konsultens lön kan påverkas.",
		redo: "Gör om",
		unsavedSummary: "{{created}} nya · {{updated}} ändrade · {{removed}} borttagna",
	},

	consultantPanel: {
		matchTab: "Matcha",
		candidatesTab: "Kandidater",
		selectConsultantsFor: "Välj konsult för {{count}} pass",
		selectedShifts: "{{count}} valda pass",
		wholeJob: "Hela uppdraget",
		requirements: "Krav",
		jobRequirements: "Uppdragets matchning",
		jobRequirementsHint: "Filtret motsvarar uppdragets kompetens och matchningskrav",
		resetRequirements: "Återställ till uppdragets matchning",
		addCertification: "Certifikat",
		addTag: "Tagg",
		allCompetences: "Alla kompetenser",
		changeCompetence: "Ändra kompetens",
		jobCompetenceMarker: "Uppdragets kompetens",
		removeSkillHint: "Ta bort för att bredda matchningen",
		notMatching: "Uppfyller inte kraven ({{count}})",
		missing: "Saknar",
		selectShiftsFirst: "Välj pass i schemat först",
		noCandidates: "Inga konsulter är bokade, önskade eller har ansökt ännu.",
		replaceBookedTitle: "Avboka bokad konsult?",
		replaceBookedDescription:
			"En konsult är redan vald som bokad, denne kommer bli avbokad när du önskar konsult(er) på samma pass. Vill du fortsätta?",
		uninvite: "Ta bort",
		shiftsUnit: "pass",
	},
	jobCandidates: {
		inboxTitle: "Ansökningar & inbjudningar",
		pendingCount: "{{count}} väntar",
		pendingCount_plural: "{{count}} väntar",
		searchTitle: "Hitta konsulter",
		appliedAt: "Ansökte {{date}}",
		invitedAt: "Önskad {{date}}",
		invitedFor: "Önskad på",
		showInSchedule: "Visa i schemat",
		willBook: "Bokas på",
		bookNShifts: "Boka {{count}} pass",
		bookShiftsTitle: "Boka {{name}}",
		chooseShifts: "Välj vilka pass som bokas",
		bookShiftsHint: "Välj vilka pass konsulten bokas på. Endast lediga pass visas.",
		overlapsSelected: "Överlappar ett valt pass",
		fullyStaffed: "Alla pass är bemannade",
		showAllShifts: "Visa alla {{count}}",
		showFewerShifts: "Visa färre",
		deleteApplication: "Ta bort",
		deleteApplicationHint: "Ta bort ansökan helt så att konsulten kan ansöka igen",
		deleteApplicationTitle: "Ta bort ansökan?",
		deleteApplicationConfirm:
			"Ansökan tas bort helt och konsulten kan ansöka om uppdraget igen. Detta går inte att ångra.",
		applicationDeleted: "Ansökan togs bort",
		earlier: "Tidigare ({{count}})",
		earlier_plural: "Tidigare ({{count}})",
		assignTag: "Tilldela/förnya tagg...",
		removeTag: "Ta bort tagg...",
		guaranteedHours: "Garantitid",
	},

	customFields: {
		inheritedFromCustomer: "Ärvd från kund",
		inheritedFromCustomerValue: "Ärvd från kund: {{value}}",
		noCustomerValue: "Inget värde på kunden",
		resetToInherited: "Återställ till ärvd",
		inheritFromCustomer: "Ärv från kund",
		noValue: "Inget",
		selectPlaceholder: "Välj…",
		ownedByCorporateGroup: "Ägs av koncern",
		noCorporateGroupValue: "Ägs av koncern · inget värde på koncernen",
		setByCorporateGroup: "Sätts av koncernen",
	},
};

export default sv;

export type AppLang = typeof sv;
